"use client";
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";

import { consumirApi } from "../../api/ph";
import Stepper, { Step } from "../Stepper";
import { FileUpload } from "../File_upload";
import DetallePreregistro from '../DetallePreregistro';
import Alerta from "../Alerta";
import ModalConfirmacion from "../ModalConfirmacion";
// import Loader from "../Loader";
import FullLoaderTramite from "../FullLoaderTramite";
import DetalleCitaContinuidad from "../DetalleCitaContinuidad";
import Calendar from '../Calendar';
import { motion, AnimatePresence } from "framer-motion";
// import { jwtDecode } from "jwt-decode";
import { FiSearch, FiPlus, FiFileText, FiCalendar, FiClock, FiCheckCircle, FiChevronRight, FiPrinter, FiX, FiLayers, FiRefreshCcw, FiXCircle, FiHelpCircle, FiMapPin, FiAlertCircle, FiHome, FiCheck, FiLock, FiUploadCloud } from "react-icons/fi";
import { startTour, stopTour } from "@ipejal/tour-manager";
import "driver.js/dist/driver.css";
import { twMerge } from "tailwind-merge";

// Evalúa si la fecha y hora de una cita ya pasaron con respecto al momento actual
export const haPasadoFechaHora = (fechaStr, horaStr) => {
  if (!fechaStr) return true;
  try {
    const cleanFecha = String(fechaStr).trim();
    let year = 0, month = 0, day = 0;

    if (cleanFecha.includes("-")) {
      const parts = cleanFecha.split("-").map((p) => parseInt(p, 10));
      if (parts[0] > 1000) {
        year = parts[0];
        month = parts[1];
        day = parts[2];
      } else {
        day = parts[0];
        month = parts[1];
        year = parts[2];
      }
    } else if (cleanFecha.includes("/")) {
      const parts = cleanFecha.split("/").map((p) => parseInt(p, 10));
      if (parts[0] > 1000) {
        year = parts[0];
        month = parts[1];
        day = parts[2];
      } else {
        day = parts[0];
        month = parts[1];
        year = parts[2];
      }
    }

    if (!year || !month || !day) return false;

    let hours = 0;
    let minutes = 0;
    if (horaStr) {
      const cleanHora = String(horaStr).trim().toLowerCase();
      const isPM = cleanHora.includes("pm") || cleanHora.includes("p.m.");
      const isAM = cleanHora.includes("am") || cleanHora.includes("a.m.");
      const nums = cleanHora.replace(/[^\d:]/g, "").split(":").map((p) => parseInt(p, 10));
      hours = nums[0] || 0;
      minutes = nums[1] || 0;

      if (isPM && hours < 12) hours += 12;
      if (isAM && hours === 12) hours = 0;
    }

    const citaDate = new Date(year, month - 1, day, hours, minutes, 0, 0);
    const ahora = new Date();

    console.log("🕒 [haPasadoFechaHora]", {
      fechaStr,
      horaStr,
      citaDate: citaDate.toString(),
      ahora: ahora.toString(),
      haPasado: ahora.getTime() > citaDate.getTime(),
    });

    return ahora.getTime() > citaDate.getTime();
  } catch (e) {
    console.error("Error al evaluar haPasadoFechaHora:", e);
    return false;
  }
};

const Validador = ({ tipoPrestamo, nombreLargo, skipValidarDisponibilidad = false, apiUrlRentas = null, refreshTrigger = 0, onRecargar = null, isIntroModalOpen = false, onDataLoaded = null, isPreregistro = false }) => {


  // const [resultado, setResultado] = useState(null);
  const [datos, setDatos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [mostrarFullLoader4s, setMostrarFullLoader4s] = useState(false);
  const hasShownCuatroLoaderRef = useRef(false);

  // Estados para Cita de Continuidad (id_catalogo_tramite == 4)
  const [citaContinuidadData, setCitaContinuidadData] = useState(null);
  const [mostrarVistaContinuidad, setMostrarVistaContinuidad] = useState(false);

  useEffect(() => {
    hasShownCuatroLoaderRef.current = false;
    setCitaContinuidadData(null);
    setMostrarVistaContinuidad(false);
  }, [tipoPrestamo]);

  const [mostrarNuevoPrestamo, setMostrarNuevoPrestamo] = useState(false);
  const [declaratoriaAceptada, setDeclaratoriaAceptada] = useState(false);
  const [archivosPorDocumento, setArchivosPorDocumento] = useState({});
  // const [mensaje, setMensaje] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  // const [respuesta, setRespuesta] = useState(null);
  // const [error, setError] = useState(null);
  const [alerta, setAlerta] = useState(null);
  const [numeroAfiliado, setNumeroAfiliado] = useState(null);
  const [requisitosDocumentos, setRequisitosDocumentos] = useState([]);
  const [id, setId] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [isResubiendoDocumentos, setIsResubiendoDocumentos] = useState(false);
  const [ofertaModalAbierto, setOfertaModalAbierto] = useState(false);
  const [seleccionOferta, setSeleccionOferta] = useState(null);
  const [aceptandoOferta, setAceptandoOferta] = useState(false);
  const [rechazandoOferta, setRechazandoOferta] = useState(false);
  const [ofertaDetalle, setOfertaDetalle] = useState(null);
  const [cargandoOfertaDetalle, setCargandoOfertaDetalle] = useState(false);
  const [rentasTramiteList, setRentasTramiteList] = useState([]);

  useEffect(() => {
    if (!mostrarNuevoPrestamo) {
      setIsResubiendoDocumentos(false);
      setId(null);
      setDeclaratoriaAceptada(false);
    }
  }, [mostrarNuevoPrestamo]);
  const [documentosYaSubidos, setDocumentosYaSubidos] = useState([]);
  const [cargandoRequisitos, setCargandoRequisitos] = useState(false);
  const [showRequisitosModal, setShowRequisitosModal] = useState(false);
  const [loadingModalRequisitos, setLoadingModalRequisitos] = useState(false);
  const [requisitosModalData, setRequisitosModalData] = useState([]);
  const [estadoPermitido, setEstadoPermitido] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openCalendar, setOpenCalendar] = useState(null);
  const [omitirValidacion, setOmitirValidacion] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const API_URL_LOGIN = process.env.REACT_APP_API_URL_LOGIN;
  const apiUrl_agendador = process.env.REACT_APP_URL_AGENDADOR;
  const apiKeyCitas = process.env.REACT_APP_API_KEY_CITAS;
  
  const [idSede, setIdSede] = useState(() => localStorage.getItem("id_sede") || null);
  const [sedesList, setSedesList] = useState([]);
  const [cargandoSedes, setCargandoSedes] = useState(!localStorage.getItem("id_sede"));

  useEffect(() => {
    // Si ya existe idSede o el trámite es de Rentas, no hacemos la consulta de sedes
    const isRentas = tipoPrestamo?.toLowerCase() === "rentas";
    if (isRentas) {
      if (!idSede) {
        setIdSede("1");
        localStorage.setItem("id_sede", "1");
      }
      setCargandoSedes(false);
      return;
    }

    const fetchSedes = async () => {
      try {
        const idTramite = parseInt(localStorage.getItem("id_catalogo_tramite")) || 19;
        
        const res = await consumirApi({
          url: `${apiUrl_agendador}/GetSedesPorTramite`,
          method: "POST",
          body: { id_catalogo_tramite: idTramite }
        });

        if (res.success && res.data?.sedes && res.data.sedes.length > 0) {
          const list = res.data.sedes;
          setSedesList(list);

          // Si no hay sede seleccionada previamente, ejecutamos lógica de asignación
          if (!idSede) {
            if (list.length === 1) {
              const singleSede = list[0].id_sede;
              setIdSede(String(singleSede));
              localStorage.setItem("id_sede", String(singleSede));
            }
          }
        } else {
          // Fallback
          if (!idSede) {
            setIdSede("1");
            localStorage.setItem("id_sede", "1");
          }
        }
      } catch (err) {
        console.error("Error al obtener sedes:", err);
        if (!idSede) {
          setIdSede("1");
          localStorage.setItem("id_sede", "1");
        }
      } finally {
        setCargandoSedes(false);
      }
    };

    fetchSedes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiUrl_agendador, tipoPrestamo]);

  const selectedSedeObj = sedesList.find(s => String(s.id_sede) === String(idSede));
  const sedeName = selectedSedeObj
    ? (selectedSedeObj.alias || selectedSedeObj.descripcion)
    : (String(idSede) === "1" ? "Edificio Central" : null);

  const puedeCambiarSede = (() => {
    // 1. Si está en el flujo activo de captura (Stepper), no se puede cambiar la sede
    if (mostrarNuevoPrestamo) return false;

    // 2. Si no hay registros/folios aún, sí se puede cambiar la sede
    if (!datos || datos.length === 0) return true;

    // 3. Obtener el folio más reciente
    const sortedDatos = [...datos].sort((a, b) => (b.id_preregistro || 0) - (a.id_preregistro || 0));
    const latestPrereg = sortedDatos[0];
    if (!latestPrereg) return true;

    const estatusDoc = latestPrereg.nombre_estado?.toUpperCase()?.trim() || "";

    // 4. Si el folio más reciente es Preregistro Rechazado o Rechazado, sí puede cambiar
    if (estatusDoc === "PREREGISTRO RECHAZADO" || estatusDoc === "RECHAZADO") {
      return true;
    }

    // 5. Si el folio más reciente es Aprobado, requiere tener cita agendada (con folio y fecha) para poder cambiar
    if (estatusDoc === "APROBADO") {
      const tieneCitaValida =
        latestPrereg.folio_cita && latestPrereg.folio_cita !== "-" &&
        latestPrereg.fecha_cita && latestPrereg.fecha_cita !== "-";
      return !!tieneCitaValida;
    }

    // Por defecto para otros estados intermedios (Pendiente, Observado, etc.), no se permite cambiar
    return false;
  })();

  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [complementariaId, setComplementariaId] = useState(null);
  const [rentasBloqueo, setRentasBloqueo] = useState(null);
  const [rentasTramiteInfo, setRentasTramiteInfo] = useState(undefined);
  const detalleRef = useRef(null);
  const hasCalledAssignEstatus1Ref = useRef(new Set());
  const tourAttempted = useRef({ list: false, stepper: false, detail: false });
  const documentoActual = requisitosDocumentos[currentStep - 1];
  const tieneNotasActivas = documentoActual?.notas_requisitos && documentoActual.notas_requisitos.filter(n => n.es_activo).length > 0;
  const [openMobileNotas, setOpenMobileNotas] = useState(false);
  const mobileScrollRef = useRef(null);
  const [showScrollDownBtn, setShowScrollDownBtn] = useState(false);

  const checkMobileScroll = useCallback(() => {
    const el = mobileScrollRef.current;
    if (el) {
      const hasMoreToScroll = el.scrollHeight > el.clientHeight + el.scrollTop + 15;
      setShowScrollDownBtn(hasMoreToScroll);
    }
  }, []);

  const handleScrollDownMobile = () => {
    const el = mobileScrollRef.current;
    if (el) {
      el.scrollBy({ top: 180, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (openMobileNotas) {
      const timer = setTimeout(checkMobileScroll, 250);
      return () => clearTimeout(timer);
    } else {
      setShowScrollDownBtn(false);
    }
  }, [openMobileNotas, currentStep, checkMobileScroll]);

  // Cerrar la nota en móvil cuando cambia el paso
  useEffect(() => {
    setOpenMobileNotas(false);

    if (tieneNotasActivas && window.innerWidth < 1024) {
      setAlerta({
        tipo: "info",
        titulo: "Indicaciones del Requisito",
        mensaje: "Este documento cuenta con indicaciones importantes que debes revisar.",
        onClick: () => {
          setOpenMobileNotas(true);
          setAlerta(null);
        }
      });
    }
  }, [currentStep, tieneNotasActivas]);

  useEffect(() => {
    const fetchUserData = async () => {
      let token = localStorage.getItem("token");
      if (!token) return;

      try {
        let response = await fetch(`${API_URL_LOGIN}/auth/me/client`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        // Si expiró el token (status 401), renovamos "invisiblemente" 
        if (response.status === 401) {
          const refreshToken = localStorage.getItem("refreshToken");
          if (!refreshToken) throw new Error("No hay refreshToken para usar");

          // Llamada para regenerar tokens
          const refreshRes = await fetch(`${API_URL_LOGIN}/auth/refresh/client`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refreshToken }),
          });

          if (refreshRes.ok) {
            const refreshData = await refreshRes.json();
            if (refreshData.ok && refreshData.data?.tokens) {
              const tokens = refreshData.data.tokens;
              token = tokens.accessToken;

              // 1. Guardar localmente los nuevos
              localStorage.setItem("token", tokens.accessToken);
              if (tokens.refreshToken) {
                localStorage.setItem("refreshToken", tokens.refreshToken);
              }

              // 2. Re-intentar la llamada de los datos del usuario 
              response = await fetch(`${API_URL_LOGIN}/auth/me/client`, {
                method: "GET",
                headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              });
            } else {
              throw new Error("Estructura de token inválida del servidor");
            }
          } else {
            throw new Error("Petición de renovación fallida o refresh expirado");
          }
        }

        // Ya con la response en orden, sacamos los datos
        const data = await response.json();
        if (data.ok && data.data && data.data.user) {
          const userObj = data.data.user;

          // Compare with existing local user to verify identity
          const localUserStr = localStorage.getItem("user");
          if (localUserStr) {
            const localUser = JSON.parse(localUserStr);
            if (localUser && (localUser.id !== userObj.id || localUser.username !== userObj.username)) {
              console.warn("Security warning: Identity mismatch detected in Validador.");
              throw new Error("Identity mismatch");
            }
          }

          const rawCode = userObj.username || "";
          const cleanCode = (typeof rawCode === "string" && rawCode.startsWith("deudo-"))
            ? (rawCode.split("-")[1] || rawCode)
            : rawCode;
          setNumeroAfiliado(cleanCode);
          setUserId(userObj.username);
          setUserEmail(userObj.email);
        }

      } catch (err) {
        console.error("❌ Fallo en sesión, requiere volver a iniciar", err);
        localStorage.clear();
        const LOGIN_URL = process.env.REACT_APP_KEYCLOAK_LOGIN_URL;
        if (LOGIN_URL) window.location.replace(LOGIN_URL);
      }
    };

    fetchUserData();
  }, []);

  // Función para cargar datos (preregistros)
  const validar = useCallback(async (isSilent = false) => {
    if (!isSilent) setCargando(true);
    try {
      const { success, data: responseData } = await consumirApi({
        url: `${apiUrl}/preregistros/listado/${userId}/${tipoPrestamo}`,
        method: "GET",
      });

      const rawData = responseData?.data || [];
      const data = rawData.map((item) => {
        if (item.nombre_estado === "Rechazado") {
          return {
            ...item,
            nombre_estado: item.tiene_bitacora ? "Rechazado" : "Observado",
          };
        }
        return item;
      });

      if (success && Array.isArray(data)) {

        if (data.length === 0) {
          // setResultado("No hay registros");
          setDatos([]);
          setRequisitosDocumentos([]);
        } else {
          const docs = data.map((item) => ({
            id_preregistro: item.id_preregistro,
            nombre_estado: item.nombre_estado,
            fecha_preregistro: item.fecha_preregistro,
          }));
          setRequisitosDocumentos(docs);
          // setResultado("todo bien");
          setDatos(data);
        }
      } else {
        // setError("No se obtuvo un arreglo de datos");
        setDatos([]);
        // setResultado("Error al cargar datos");
        console.warn("❗ No se obtuvo un arreglo de datos válido");
      }

      // Validar id_catalogo_tramite si es 4 en /preregistro
      const idCatalogo = responseData?.id_catalogo_tramite 
        ?? responseData?.data?.id_catalogo_tramite 
        ?? (Array.isArray(rawData) && rawData.length > 0 ? rawData[0]?.id_catalogo_tramite : null);

      console.log("🔍 [Preregistro] id_catalogo_tramite detectado:", idCatalogo);

      const isIdCuatro = (Number(idCatalogo) === 4 || String(idCatalogo) === "4");
      const esRutaPreregistro = isPreregistro || (typeof window !== "undefined" && window.location.pathname.includes("/preregistro"));

      if (idCatalogo !== undefined && idCatalogo !== null) {
        localStorage.setItem("id_catalogo_tramite", String(idCatalogo));
      }

      // Verificar el preregistro más reciente y si cuenta con Folio Cita
      const sortedPreregistros = Array.isArray(data)
        ? [...data].sort((a, b) => (b.id_preregistro || 0) - (a.id_preregistro || 0))
        : [];
      const masReciente = sortedPreregistros[0];
      
      const rawFolioCita = masReciente?.folio_cita;
      const tieneFolioCitaValido = rawFolioCita !== undefined && 
        rawFolioCita !== null && 
        String(rawFolioCita).trim() !== "" && 
        String(rawFolioCita).trim() !== "-";

      const folioCitaMasReciente = tieneFolioCitaValido ? String(rawFolioCita).trim() : null;

      // Solo si id_catalogo_tramite == 4, en /preregistro, y SÍ tiene folio_cita más reciente
      if (esRutaPreregistro && isIdCuatro && (!isSilent || !hasShownCuatroLoaderRef.current)) {
        hasShownCuatroLoaderRef.current = true;

        if (tieneFolioCitaValido && folioCitaMasReciente) {
          setMostrarFullLoader4s(true);
          try {
            // Extraer únicamente el código de afiliado (solo código, sin 'Usuario: ')
            let storedUsername = "";
            try {
              const u = JSON.parse(localStorage.getItem("user") || "{}");
              storedUsername = u.username || "";
            } catch (e) {}

            const rawCodigo = numeroAfiliado || userId || storedUsername || "2020110244";
            const cleanCode = (typeof rawCodigo === "string" && rawCodigo.startsWith("deudo-"))
              ? (rawCodigo.split("-")[1] || rawCodigo)
              : String(rawCodigo).replace(/^Usuario:\s*/i, "").trim();

            const payloadContinuidad = {
              codigo_afiliado: cleanCode,
              folios: [folioCitaMasReciente]
            };

            console.log("📤 [GetCitasContinuidad] Enviando petición a:", `${apiUrl_agendador}/GetCitasContinuidad`, payloadContinuidad);

            // Garantizar tiempo mínimo de 3 segundos para que el loader en pantalla completa se aprecie fluidamente
            const [resContinuidad] = await Promise.all([
              consumirApi({
                url: `${apiUrl_agendador}/GetCitasContinuidad`,
                method: "POST",
                headers: {
                  'x-api-key': apiKeyCitas
                },
                body: payloadContinuidad
              }),
              new Promise((resolve) => setTimeout(resolve, 3000))
            ]);

            console.log("📥 [GetCitasContinuidad] Respuesta:", resContinuidad);

            if (!resContinuidad || !resContinuidad.success) {
              console.warn("⚠️ [GetCitasContinuidad] El servicio de continuidad no respondió exitosamente:", resContinuidad);
              setCitaContinuidadData(null);
              setMostrarVistaContinuidad(false);
              setAlerta({
                tipo: "warning",
                titulo: "Servicio de Citas",
                mensaje: "El servicio de continuidad no está activo en este momento.",
                duration: 6000,
              });
              return;
            }

            const resultadoItem = resContinuidad?.data?.resultados?.[0];
            const tieneContinuidad = Boolean(
              resultadoItem?.tiene_continuidad &&
              Array.isArray(resultadoItem?.citas_continuidad) &&
              resultadoItem.citas_continuidad.length > 0
            );

            if (tieneContinuidad) {
              const primerContinuidad = resultadoItem.citas_continuidad[0];
              const yaPaso = haPasadoFechaHora(primerContinuidad.fecha_cita, primerContinuidad.hora_cita);

              if (yaPaso) {
                console.log(
                  `ℹ️ [Cita Continuidad] La fecha y hora de la cita ya pasaron (${primerContinuidad.fecha_cita} ${primerContinuidad.hora_cita}). Se mantiene la vista normal.`
                );
                setCitaContinuidadData(null);
                setMostrarVistaContinuidad(false);
              } else {
                console.log("✅ [Cita Continuidad] Cita vigente encontrada. Mostrando en pantalla completa.");
                setCitaContinuidadData({
                  ...primerContinuidad,
                  codigo_afiliado: cleanCode,
                  cita_origen: resultadoItem.cita_origen || null,
                });
                setMostrarVistaContinuidad(true);
              }
            } else {
              console.log("ℹ️ [Cita Continuidad] No tiene cita de continuidad activa.");
              setCitaContinuidadData(null);
              setMostrarVistaContinuidad(false);
            }
          } catch (errContinuidad) {
            console.error("❌ Error al consumir /GetCitasContinuidad:", errContinuidad);
            setCitaContinuidadData(null);
            setMostrarVistaContinuidad(false);
            setAlerta({
              tipo: "warning",
              titulo: "Servicio de Citas",
              mensaje: "El servicio de continuidad no está activo en este momento.",
              duration: 6000,
            });
          } finally {
            setMostrarFullLoader4s(false);
          }
        } else {
          console.log("ℹ️ [GetCitasContinuidad] El folio más reciente (#" + (masReciente?.folio || masReciente?.id_preregistro) + ") no tiene Folio Cita (valor actual: '" + rawFolioCita + "'). No se consume la API.");
          setCitaContinuidadData(null);
          setMostrarVistaContinuidad(false);
        }
      }
    } catch (error) {
      console.error("❌ Error en validar:", error);
      // setError("Error en la solicitud");
      setDatos([]);
      // setResultado("Error al cargar datos");
    } finally {
      setMostrarFullLoader4s(false);
      if (!isSilent) setCargando(false);
    }
  }, [apiUrl, userId, tipoPrestamo, isPreregistro, apiUrl_agendador, apiKeyCitas, numeroAfiliado]);

  useEffect(() => {
    if (userId) {
      validar();
    }
  }, [userId, validar]);

  const fetchRentasTramiteInfo = useCallback(async () => {
      const rentasApiUrl = apiUrlRentas || process.env.REACT_APP_API_URL_RENTAS;
      if (!rentasApiUrl || !numeroAfiliado || tipoPrestamo?.toLowerCase() !== "rentas") {
        setRentasTramiteInfo(null);
        setRentasTramiteList([]);
        return;
      }
      try {
        const res = await fetch(`${rentasApiUrl}/validar_usuario_tramite/${numeroAfiliado}`);
        if (res.ok) {
          const data = await res.json();
          const list = Array.isArray(data) ? data : [data];
          setRentasTramiteList(list);
          const info = list[0];
          setRentasTramiteInfo(info || null);
        } else {
          setRentasTramiteInfo(null);
          setRentasTramiteList([]);
        }
      } catch (err) {
        console.error("Error al obtener validar_usuario_tramite para fila virtual:", err);
        setRentasTramiteInfo(null);
      }
    }, [apiUrlRentas, numeroAfiliado, tipoPrestamo]);

  useEffect(() => {
    fetchRentasTramiteInfo();
  }, [fetchRentasTramiteInfo]);

  useEffect(() => {
    if (onDataLoaded) {
      onDataLoaded({ rentasTramiteList, datos });
    }
  }, [rentasTramiteList, datos, onDataLoaded]);

  useEffect(() => {
    if (tipoPrestamo?.toLowerCase() !== "rentas") return;

    const checkYAsignarEstatus1 = async () => {
      // Buscar si entre la lista de trámites de Rentas existe alguno en Renovación
      const renovacionItem = rentasTramiteList?.find(i => {
        const est = i?.tramite_estatus?.toUpperCase()?.trim() || "";
        return est.includes("RENOVAC") || est === "EN RENOVACIÓN" || est === "EN RENOVACION";
      });

      const info = renovacionItem || rentasTramiteInfo || (rentasTramiteList && rentasTramiteList.length > 0 ? rentasTramiteList[0] : null);

      console.log("[Rentas - checkYAsignarEstatus1 - evaluando]", {
        tipoPrestamo,
        hasInfo: Boolean(info),
        tramite_estatus: info?.tramite_estatus,
        rentasTramiteListLength: rentasTramiteList?.length,
        datosLength: datos?.length,
        numeroAfiliado,
        apiUrlRentas: apiUrlRentas || process.env.REACT_APP_API_URL_RENTAS
      });

      if (!info || !datos || datos.length === 0) {
        console.log("[Rentas] No se ejecuta asignación de estatus: falta info de rentas o listado de datos.");
        return;
      }

      const isRentas = tipoPrestamo?.toLowerCase() === "rentas";
      const estatusStr = info.tramite_estatus?.toUpperCase()?.trim() || "";
      const isEnRenovacion = estatusStr.includes("RENOVAC") || estatusStr === "EN RENOVACIÓN" || estatusStr === "EN RENOVACION";

      if (!isRentas) {
        console.log("[Rentas] No se ejecuta: tipoPrestamo no es rentas (es:", tipoPrestamo, ")");
        return;
      }

      if (!isEnRenovacion) {
        console.log("[Rentas] No se ejecuta: el estatus de Rentas no es En Renovación (es:", estatusStr, ")");
        return;
      }

      // Obtener ÚNICAMENTE el preregistro (folio) más reciente
      const sortedDatos = [...datos].sort((a, b) => (b.id_preregistro || 0) - (a.id_preregistro || 0));
      const latestPrereg = sortedDatos[0];

      if (!latestPrereg) {
        console.log("[Rentas] No se encontró un preregistro reciente.");
        return;
      }

      // Verificar que el folio más reciente esté Aprobado
      const estadoNombre = (latestPrereg.nombre_estado || "").toUpperCase().trim();
      const idEstatus = Number(latestPrereg.id_preregistro_estado || latestPrereg.id_estado);
      const isAprobado = estadoNombre.includes("APROBAD") || idEstatus === 2;

      console.log("[Rentas - comprobación de folio más reciente]", {
        latestPreregId: latestPrereg.id_preregistro,
        latestPreregFolio: latestPrereg.folio,
        latestPreregEstado: latestPrereg.nombre_estado,
        idEstatus,
        isAprobado,
        infoFolio: info.folio_tramite
      });

      if (!isAprobado) {
        console.log("[Rentas] No se ejecuta: el folio más reciente no está Aprobado (estado actual:", latestPrereg.nombre_estado, ")");
        return;
      }

      const rentasApiUrl = apiUrlRentas || process.env.REACT_APP_API_URL_RENTAS;
      const rawFolio = latestPrereg.folio || info.folio_tramite || latestPrereg.id_preregistro;
      
      const formatRentasFolio = (f) => {
        if (!f) return null;
        const str = String(f).trim();
        const base = str.includes('-') ? str.split('-')[0] : str;
        const upper = base.toUpperCase();
        return upper.endsWith('R') ? upper : `${upper}R`;
      };

      const folioToAssign = formatRentasFolio(rawFolio);

      if (folioToAssign && hasCalledAssignEstatus1Ref.current.has(folioToAssign)) {
        console.log("[Rentas] Se omite asignación de estatus 1: ya fue ejecutada para el folio", folioToAssign);
        return;
      }

      if (rentasApiUrl && folioToAssign) {
        hasCalledAssignEstatus1Ref.current.add(folioToAssign);
        try {
          console.log(`[Rentas] ¡Regla cumplida! Llamando a ${rentasApiUrl}/tramite_asignar_estatus/1/${folioToAssign}...`);
          const resEstatus = await fetch(`${rentasApiUrl}/tramite_asignar_estatus/1/${folioToAssign}`);
          console.log("[Rentas - respuesta tramite_asignar_estatus 1]", resEstatus.status, resEstatus.ok);
          if (resEstatus.ok) {
            console.log("[Rentas] Estatus asignado con éxito a 1 (GET)");
            fetchRentasTramiteInfo();
          } else {
            console.error("[Rentas] Error al asignar estatus 1 (GET):", resEstatus.statusText);
          }
        } catch (e) {
          console.error("[Rentas] Error al llamar tramite_asignar_estatus 1:", e);
        }
      } else {
        console.warn("[Rentas] No se pudo realizar la llamada: falta rentasApiUrl o folioToAssign", { rentasApiUrl, folioToAssign });
      }
    };

    checkYAsignarEstatus1();
  }, [rentasTramiteInfo, rentasTramiteList, datos, tipoPrestamo, apiUrlRentas, fetchRentasTramiteInfo, numeroAfiliado]);





  // Refrescar tabla y estado Rentas cuando el padre incrementa refreshTrigger
  useEffect(() => {
    if (refreshTrigger > 0 && userId) {
      validar(true); // silent refresh
      fetchRentasTramiteInfo();
    }
  }, [refreshTrigger, userId, validar, fetchRentasTramiteInfo]);

  const obtenerEstatusRentasPorFolio = (rowFolio) => {
    if (!rowFolio || !rentasTramiteList || rentasTramiteList.length === 0) return null;
    
    const cleanFolio = (f) => f ? String(f).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    const cleanRowFolio = cleanFolio(rowFolio);
    
    const match = rentasTramiteList.find(item => {
      if (!item || !item.folio_tramite) return false;
      const baseFolio = item.folio_tramite.endsWith('R')
        ? item.folio_tramite.slice(0, -1)
        : item.folio_tramite;
        
      const cleanBase = cleanFolio(baseFolio);
      const cleanFull = cleanFolio(item.folio_tramite);
      
      return cleanRowFolio === cleanBase || cleanRowFolio === cleanFull;
    });
    
    return match ? match.tramite_estatus : null;
  };

  const obtenerFolioFilaVirtual = (rowFolio) => {
    if (!rowFolio || !rentasTramiteList || rentasTramiteList.length === 0) return "SIN INICIAR";
    
    const cleanFolio = (f) => f ? String(f).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
    const cleanRowFolio = cleanFolio(rowFolio);
    
    const match = rentasTramiteList.find(item => {
      if (!item || !item.folio_tramite) return false;
      const baseFolio = item.folio_tramite.endsWith('R')
        ? item.folio_tramite.slice(0, -1)
        : item.folio_tramite;
        
      const cleanBase = cleanFolio(baseFolio);
      const cleanFull = cleanFolio(item.folio_tramite);
      
      return cleanRowFolio === cleanBase || cleanRowFolio === cleanFull;
    });
    
    return match ? `${rowFolio}-11-R` : "SIN INICIAR";
  };

  const obtenerOfertasDisponibles = () => {
    if (!ofertaDetalle) return [];
    const ofertas = [];
    const keys = Object.keys(ofertaDetalle);
    
    for (let i = 1; i <= 3; i++) {
      const ofertaKey = keys.find(k => k.toLowerCase() === `oferta ${i}`);
      const opcionKey = keys.find(k => k.toLowerCase() === `opción ${i}` || k.toLowerCase() === `opcion ${i}`);
      const claveKey = keys.find(k => k.toLowerCase() === `clave opción ${i}` || k.toLowerCase() === `clave opcion ${i}`);
      
      const ofertaVal = ofertaKey ? ofertaDetalle[ofertaKey] : null;
      const opcionVal = opcionKey ? ofertaDetalle[opcionKey] : null;
      const claveVal = claveKey ? ofertaDetalle[claveKey] : null;
      
      if (ofertaVal !== null && ofertaVal !== undefined && String(ofertaVal).trim() !== "" && String(ofertaVal).trim().toLowerCase() !== "null") {
        ofertas.push({
          numero: i,
          oferta: ofertaVal,
          opcion: opcionVal || `Opción ${i}`,
          clave: claveVal || "-"
        });
      }
    }
    return ofertas;
  };

  const cargarOfertaDetalle = useCallback(async () => {
    if (!rentasTramiteInfo?.folio_tramite) return;
    
    setCargandoOfertaDetalle(true);
    const rentasApiUrl = apiUrlRentas || process.env.REACT_APP_API_URL_RENTAS;
    try {
      const res = await fetch(`${rentasApiUrl}/lista_espera_tramite_detalle/${rentasTramiteInfo.folio_tramite}`);
      if (res.ok) {
        const data = await res.json();
        const info = Array.isArray(data) ? data[0] : data;
        setOfertaDetalle(info || null);
      } else {
        console.error("Error al obtener detalle de la oferta:", res.statusText);
      }
    } catch (err) {
      console.error("Error al conectar con la API de detalle de oferta:", err);
    } finally {
      setCargandoOfertaDetalle(false);
    }
  }, [rentasTramiteInfo, apiUrlRentas]);

  useEffect(() => {
    if (ofertaModalAbierto) {
      cargarOfertaDetalle();
    } else {
      setOfertaDetalle(null);
    }
  }, [ofertaModalAbierto, cargarOfertaDetalle]);

  const handleAceptarOferta = async () => {
    if (!seleccionOferta || !rentasTramiteInfo?.folio_tramite) return;

    setAceptandoOferta(true);
    const rentasApiUrl = apiUrlRentas || process.env.REACT_APP_API_URL_RENTAS;
    
    try {
      const res = await fetch(`${rentasApiUrl}/aceptar_oferta/${seleccionOferta}/${rentasTramiteInfo.folio_tramite}`);
      let resData = null;
      try {
        resData = await res.json();
      } catch (e) {
        // En caso de que no sea JSON
      }

      const isSuccess = res.ok && (!resData || resData.ok !== false);

      if (isSuccess) {
        setAlerta({
          tipo: "success",
          titulo: "Oferta Aceptada",
          mensaje: resData?.message || "La oferta del inmueble ha sido aceptada con éxito."
        });
        setOfertaModalAbierto(false);
        setSeleccionOferta(null);
        
        await fetchRentasTramiteInfo();
        if (onRecargar) onRecargar();
      } else {
        let mensajeAmigable = "";

        if (resData) {
          if (Array.isArray(resData.data) && resData.data.length > 0) {
            const itemError = resData.data[0];
            if (typeof itemError === "string") {
              mensajeAmigable = itemError;
            } else if (itemError?.error) {
              mensajeAmigable = itemError.error;
            } else if (itemError?.message || itemError?.mensaje) {
              mensajeAmigable = itemError.message || itemError.mensaje;
            }
          } else if (typeof resData.data === "string") {
            mensajeAmigable = resData.data;
          } else if (resData.data?.error) {
            mensajeAmigable = resData.data.error;
          }

          if (!mensajeAmigable) {
            if (resData.error && typeof resData.error === "string") {
              mensajeAmigable = resData.error;
            } else if (resData.message && resData.message !== "Error al ejecutar el proceso.") {
              mensajeAmigable = resData.message;
            } else if (resData.detail) {
              mensajeAmigable = typeof resData.detail === "string" ? resData.detail : JSON.stringify(resData.detail);
            }
          }
        }

        if (!mensajeAmigable) {
          mensajeAmigable = "Esta oferta no está disponible debido a que el tiempo para aceptarla ha expirado.";
        }

        setAlerta({
          tipo: "warning",
          titulo: "Oferta no disponible",
          mensaje: mensajeAmigable
        });
        setOfertaModalAbierto(false);
        setSeleccionOferta(null);
        await fetchRentasTramiteInfo();
        if (onRecargar) onRecargar();
      }
    } catch (err) {
      console.error("Error al aceptar oferta:", err);
      setAlerta({
        tipo: "error",
        titulo: "Error al procesar",
        mensaje: err.message || "Ocurrió un error al intentar aceptar la oferta. Intente de nuevo."
      });
    } finally {
      setAceptandoOferta(false);
    }
  };

  const handleRechazarOferta = async () => {
    if (!rentasTramiteInfo?.folio_tramite) return;

    setRechazandoOferta(true);
    const rentasApiUrl = apiUrlRentas || process.env.REACT_APP_API_URL_RENTAS;
    const rawFolio = rentasTramiteInfo.folio_tramite;
    const folio = String(rawFolio).endsWith('R') ? String(rawFolio) : `${rawFolio}R`;

    try {
      const res = await fetch(`${rentasApiUrl}/tramites_rechazar_ofertas/${folio}`);
      if (res.ok) {
        setAlerta({
          tipo: "success",
          mensaje: "La oferta del inmueble ha sido rechazada con éxito."
        });
        setOfertaModalAbierto(false);
        setSeleccionOferta(null);
        
        await fetchRentasTramiteInfo();
        if (onRecargar) onRecargar();
      } else {
        const errorText = await res.text();
        throw new Error(errorText || "Error del servidor al rechazar la oferta");
      }
    } catch (err) {
      console.error("Error al rechazar oferta:", err);
      setAlerta({
        tipo: "error",
        mensaje: err.message || "Ocurrió un error al intentar rechazar la oferta. Intente de nuevo."
      });
    } finally {
      setRechazandoOferta(false);
    }
  };

  const mostrarBtnIniciarTramite = (() => {
    // Si no hay datos / tabla vacía, se muestra el botón Iniciar Trámite
    if (!datos || datos.length === 0) return true;

    // Obtener el folio más reciente de la tabla
    const sortedDatos = [...datos].sort((a, b) => (b.id_preregistro || 0) - (a.id_preregistro || 0));
    const latestPrereg = sortedDatos[0];
    if (!latestPrereg) return true;

    const estatusDoc = latestPrereg.nombre_estado?.toUpperCase()?.trim() || "";
    const idEstatusDoc = Number(latestPrereg.id_preregistro_estado || latestPrereg.id_estado);

    const esObservado = estatusDoc === "OBSERVADO" || estatusDoc === "CON OBSERVACIONES" || estatusDoc.includes("OBSERV");

    // 1. Si es Rechazado o Preregistro Rechazado (excluyendo si es Observado)
    const esRechazado = 
      !esObservado && (
        estatusDoc === "RECHAZADO" ||
        estatusDoc === "PREREGISTRO RECHAZADO" ||
        ((idEstatusDoc === 3 || idEstatusDoc === 5) && !estatusDoc.includes("OBSERV"))
      );

    // 2. Si es Cancelado
    const esCancelado = estatusDoc === "CANCELADO";

    // Si es el trámite específico de Rentas, se muestra si está rechazado, cancelado o si su estatus en rentas es VENCIDO o CONCLUIDO
    if (tipoPrestamo?.toLowerCase() === "rentas") {
      let estatusRentas = (obtenerEstatusRentasPorFolio(latestPrereg.folio) || "")
        .toUpperCase()
        .trim();

      // Si no obtuvo estatus por folio directamente, verificar contra la lista de rentas
      if (!estatusRentas) {
        const itemRentas = (rentasTramiteList && rentasTramiteList.length > 0) ? rentasTramiteList[0] : rentasTramiteInfo;
        if (itemRentas?.tramite_estatus) {
          const cleanFolio = (f) => f ? String(f).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
          const cleanRowFolio = cleanFolio(latestPrereg.folio);
          const cleanItemFolio = cleanFolio(itemRentas.folio_tramite);
          const baseItemFolio = itemRentas.folio_tramite?.endsWith('R') ? cleanFolio(itemRentas.folio_tramite.slice(0, -1)) : cleanItemFolio;

          if (!cleanRowFolio || cleanRowFolio === cleanItemFolio || cleanRowFolio === baseItemFolio || cleanItemFolio.startsWith(cleanRowFolio) || cleanRowFolio.startsWith(baseItemFolio)) {
            estatusRentas = (itemRentas.tramite_estatus || "").toUpperCase().trim();
          }
        }
      }

      const isEnRenovacion = estatusRentas.includes("RENOVAC") || estatusRentas === "EN RENOVACIÓN" || estatusRentas === "EN RENOVACION";

      const esVencidoOConcluido = 
        estatusRentas === "VENCIDO" || 
        estatusRentas === "CONCLUIDO" || 
        estatusRentas === "CONCLUIDA";

      // Si en Rentas ya está Vencido o Concluido, siempre permite Iniciar Trámite (terminó el trámite sin importar si tenía docs observados)
      if (esVencidoOConcluido) {
        return true;
      }

      // Si los documentos están Observados o si en Rentas está En Renovación, NO se debe mostrar Iniciar Trámite
      if (esObservado || isEnRenovacion) {
        return false;
      }

      return esRechazado || esCancelado;
    }

    // 3. Si es Aprobado, pero SOLO si Folio Cita y Fecha Cita tienen datos (no vacíos ni "-")
    const tieneCitaValida = 
      latestPrereg.folio_cita && latestPrereg.folio_cita !== "-" &&
      latestPrereg.fecha_cita && latestPrereg.fecha_cita !== "-";

    const esAprobadoConCita = estatusDoc === "APROBADO" && tieneCitaValida;

    return esRechazado || esCancelado || esAprobadoConCita;
  })();

  const hideFolioAndFecha = (() => {
    if (tipoPrestamo?.toLowerCase() !== "rentas") return false;
    if (rentasTramiteInfo === undefined) return false;
    if (rentasTramiteInfo === null) return true;

    const idTramiteVal = rentasTramiteInfo.id_tramite;
    const estatusVal = rentasTramiteInfo.tramite_estatus;

    const idTramiteNull = idTramiteVal === null || 
                          idTramiteVal === undefined ||
                          String(idTramiteVal).toLowerCase() === "null" ||
                          String(idTramiteVal).toLowerCase() === "nulo" ||
                          String(idTramiteVal).trim() === "";

    const tramiteEstatusNull = estatusVal === null || 
                               estatusVal === undefined ||
                               String(estatusVal).toLowerCase() === "null" ||
                               String(estatusVal).toLowerCase() === "nulo" ||
                               String(estatusVal).trim() === "";

    return idTramiteNull && tramiteEstatusNull;
  })();
  // Cargar preregistro y documentos cuando mostrarNuevoPrestamo es true
  useEffect(() => {
    if (mostrarNuevoPrestamo && numeroAfiliado && userId) {
      const fetchTodo = async () => {
        setCargandoRequisitos(true);
        try {
          const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
          const correo_electronico = storedUser?.email || userEmail || "";

          let preregistroId = id;
          if (!isResubiendoDocumentos) {
            const response = await fetch(`${apiUrl}/getPreregistro/`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ numeroAfiliado, tipoPrestamo, id_user: userId, correo_electronico }),
            });

            if (!response.ok) throw new Error(`Error: ${response.statusText}`);
            const preregistroData = await response.json();
            preregistroId = preregistroData.resultado.id;
            setId(preregistroId);
          }

          // Validación de usuario para Rentas (solo si viene de /tramite/Rentas)
          if (apiUrlRentas) {
            try {
              const validRes = await fetch(`${apiUrlRentas}/validar_usuario_tramite/${numeroAfiliado}`);
              if (!validRes.ok) {
                setRentasBloqueo({
                  titulo: "Error de validación",
                  mensaje: "No fue posible validar su estado en el sistema de rentas. Intente más tarde o contacte a soporte.",
                  tipo: "error"
                });
                setMostrarNuevoPrestamo(false);
                return;
              }
              const validData = await validRes.json();
              console.log("[Rentas] Respuesta validar_usuario_tramite:", validData);

              // La API devuelve un array, tomamos el primer elemento
              const usuario = Array.isArray(validData) ? validData[0] : validData;

              if (!usuario) {
                setRentasBloqueo({
                  titulo: "Afiliado no encontrado",
                  mensaje: "No se encontró información de su cuenta en el sistema de rentas. Verifique su número de afiliado o contacte a soporte.",
                  tipo: "error"
                });
                setMostrarNuevoPrestamo(false);
                return;
              }

              // Validar estatus de plaza: debe ser "ACTIVO"
              if (usuario.estatus_plaza && usuario.estatus_plaza.toUpperCase() !== "ACTIVO") {
                setRentasBloqueo({
                  titulo: "Estatus de plaza no válido",
                  mensaje: `Su estatus de plaza actual es "${usuario.estatus_plaza}". Para realizar este trámite de renta se requiere que su plaza se encuentre en estatus ACTIVO.`,
                  detalle: `Estatus actual: ${usuario.estatus_plaza}`,
                  tipo: "plaza"
                });
                setMostrarNuevoPrestamo(false);
                return;
              }

              // Validar préstamo PH: debe ser null (sin préstamo previo)
              if (usuario.prestamo_ph !== null && usuario.prestamo_ph !== undefined) {
                setRentasBloqueo({
                  titulo: "Préstamo hipotecario detectado",
                  mensaje: `Se detectó que usted cuenta con un préstamo hipotecario (PH) registrado. Mientras tenga un trámite de PH activo o previo, no es posible solicitar un trámite de renta.`,
                  detalle: `Préstamo PH: ${usuario.prestamo_ph}`,
                  tipo: "ph"
                });
                setMostrarNuevoPrestamo(false);
                return;
              }
            } catch (err) {
              console.error("❌ Error al validar usuario para rentas:", err);
              setRentasBloqueo({
                titulo: "Error de conexión",
                mensaje: "No fue posible conectar con el servidor de validación de rentas. Verifique su conexión e intente nuevamente.",
                tipo: "error"
              });
              setMostrarNuevoPrestamo(false);
              return;
            }
          }

          const { success, data } = await consumirApi({
            url: `${apiUrl}/requisitos/documentos/${tipoPrestamo}`,
            method: "GET",
          });

          if (success) {
            const compItem = data.find(item =>
              (item.tipo_documento?.nombre || "").toLowerCase().includes("complementaria")
            );
            const compId = compItem?.tipo_documento?.id_tipo_documento;
            setComplementariaId(compId);

            const filteredDocs = data.filter(item => {
              if (!item.tipo_documento) return false;
              const name = (item.tipo_documento.nombre || "").toLowerCase();
              return !name.includes("complementaria");
            }).map(item => ({
              nombre: item.tipo_documento.nombre,
              tipo_archivo: item.tipo_documento.tipo_archivo,
              requerido: item.tipo_documento.es_requerido,
              partes: item.partes,
              tipo_prestamo: item.tipo_prestamo,
              id_tipo_documento: item.tipo_documento.id_tipo_documento,
              pre: item.id_requisito_documento,
              complementariaId: compId,
              es_complementario_permitido: item.es_complementario_permitido,
              limite_documento_complementario: item.limite_documento_complementario,
              es_obligatorio: item.es_obligatorio !== undefined ? item.es_obligatorio : true,
              notas_requisitos: item.notas_requisitos || []
            }));

            const omitir = data.length > 0 && data[0].tipo_prestamo?.es_omitir_validacion;
            setOmitirValidacion(!!omitir);
            if (omitir) {
              setCurrentStep(filteredDocs.length + 1);
            } else {
              setCurrentStep(1);
            }

            setRequisitosDocumentos(filteredDocs);
          }
        } catch (error) {
          console.error("❌ Error al obtener requisitos:", error);
        } finally {
          setCargandoRequisitos(false);
        }
      };
      fetchTodo();
    }
  }, [mostrarNuevoPrestamo, numeroAfiliado, userId, apiUrl, tipoPrestamo, apiUrlRentas, userEmail, isResubiendoDocumentos, id]);

  const handleComplementariaUpload = async (e, limite = null, idRequisitoDocumento) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    // Validar límite de tamaño desde .env (o 10 MB por defecto)
    const maxFileSizeMb = Number(process.env.REACT_APP_MAX_FILE_SIZE_MB) || 10;
    const MAX_FILE_SIZE = maxFileSizeMb * 1024 * 1024;
    const invalidFiles = files.filter(f => f.size > MAX_FILE_SIZE);
    if (invalidFiles.length > 0) {
      setAlerta({ tipo: "warning", mensaje: `El archivo "${invalidFiles[0].name}" supera el límite de tamaño permitido (máximo ${maxFileSizeMb} MB).` });
      e.target.value = ""; // Resetear input
      return;
    }

    if (limite && files.length > limite) {
      setAlerta({ tipo: "warning", mensaje: `Solo puedes subir hasta ${limite} archivos complementarios a la vez.` });
      e.target.value = "";
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target.result);
        reader.readAsDataURL(file);
      });

      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      const filename = `${uuid}_${file.name}`;

      try {
        const res = await fetch(
          `${apiUrl}/upload-complementario-base64?id_preregistro=${id}&id_requisito_documento=${idRequisitoDocumento}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ base64, filename }),
          }
        );

        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          setAlerta({ tipo: "error", mensaje: errorData.detail || errorData.message || "Error al subir documento complementario." });
          e.target.value = "";
          return;
        }

        if (i === files.length - 1) {
          setAlerta({ tipo: "success", mensaje: "Documentos complementarios agregados correctamente." });
        }
      } catch (error) {
        console.error("❌ Error al subir complemento:", error);
        setAlerta({ tipo: "error", mensaje: "No se pudo subir el documento complementario." });
        e.target.value = "";
        return;
      }
    }

    e.target.value = "";
  };

  // Agregar archivos sin duplicados
  /*
  const agregarArchivosSinDuplicados = (prev, doc, nuevosArchivos) => {
    const existentes = prev[doc] || [];
    const combinados = [...existentes, ...nuevosArchivos];
    const sinDuplicados = Array.from(
      new Map(combinados.map((f) => [f.name, f])).values()
    );
    return { ...prev, [doc]: sinDuplicados };
  };
  */

  // Validación si puede avanzar el paso actual
  const puedeAvanzarPasoActual = (() => {
    if (omitirValidacion) return true;

    const index = currentStep - 1;

    if (index >= requisitosDocumentos.length) {
      if (tipoPrestamo?.toLowerCase() === "rentas" && !declaratoriaAceptada) {
        return false;
      }
      return true;
    }

    const documentoActual = requisitosDocumentos[index];
    if (!documentoActual) return false;

    if (documentosYaSubidos.includes(documentoActual.pre) && !isResubiendoDocumentos) return true;

    // Si el documento NO es obligatorio, siempre puede avanzar
    if (documentoActual.es_obligatorio === false) return true;

    const partesObligatorias = Array.isArray(documentoActual.partes)
      ? documentoActual.partes.filter((p) => p.es_obligatorio)
      : [];

    const cantidadPartesObligatorias = partesObligatorias.length;

    const archivos = archivosPorDocumento[documentoActual.nombre] || [];

    return archivos.length >= cantidadPartesObligatorias;
  })();

  // Tabla
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [rowSelection, setRowSelection] = useState({});
  const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
  const [detalleDocumento, setDetalleDocumento] = useState(null);
  const [detalleDocumento_sub, setDetalleDocumento_sub] = useState(null);
  const [globalFilter, setGlobalFilter] = React.useState("");


  useEffect(() => {
    if (registroSeleccionado && !loading) {
      const timer = setTimeout(() => {
        if (detalleRef.current) {
          detalleRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [registroSeleccionado, loading]);
  const GetCitasDisponibles = useCallback(async () => {
    if (!idSede) return;
    try {
      const body = {
        id_sede: parseInt(idSede),
        id_catalogo_tramite: parseInt(localStorage.getItem("id_catalogo_tramite")) || 19
      };

      const res = await consumirApi({
        url: `${apiUrl_agendador}/GetCitasDisponibles`,
        method: "POST",
        body
      });

      if (!res.success) {
        console.error("Error al obtener citas:", res.message);
        return;
      }

      // const datos_citas = res.data?.data || []; // rename to avoid conflict
    } catch (error) {
      console.error("Error al validar estado:", error);
    }
  }, [apiUrl_agendador, idSede]);

  const handleIniciarTramite = useCallback(async () => {
    if (!idSede) return;
    stopTour(); // Cierra el tour si estaba activo para que no quede colgando al cambiar el estado del componente

    // Si se indica saltar la validación de disponibilidad, iniciar directo
    if (skipValidarDisponibilidad) {
      setMostrarNuevoPrestamo(true);
      return;
    }

    try {
      const response = await fetch(`${apiUrl_agendador}/validarDisponibilidadActual`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          codigo_afiliado: numeroAfiliado,
          id_sede: parseInt(idSede)
        }),
      });

      if (!response.ok) {
        setAlerta({ tipo: "error", mensaje: "Error al validar disponibilidad actual." });
        return;
      }

      const resData = await response.json();

      if (resData.success && resData.puede_agendar) {
        setMostrarNuevoPrestamo(true);
      } else {
        setAlerta({
          tipo: "error",
          mensaje: resData.message || "Ha alcanzado los límites de trámites al mes."
        });
      }
    } catch (err) {
      console.error("Error al validar disponibilidad:", err);
      setAlerta({ tipo: "error", mensaje: "Ocurrió un error al conectar con el servidor de citas." });
    }
  }, [skipValidarDisponibilidad, apiUrl_agendador, numeroAfiliado, idSede]);

  const handleVerRequisitos = useCallback(async () => {
    setShowRequisitosModal(true);
    if (requisitosModalData.length > 0) return;

    setLoadingModalRequisitos(true);
    try {
      const { success, data } = await consumirApi({
        url: `${apiUrl}/requisitos/documentos/${tipoPrestamo}`,
        method: "GET",
      });

      if (success && Array.isArray(data)) {
        const filteredDocs = data
          .filter((item) => {
            if (!item.tipo_documento) return false;
            const name = (item.tipo_documento.nombre || "").toLowerCase();
            return !name.includes("complementaria");
          })
          .map((item) => ({
            nombre: item.tipo_documento.nombre,
            requerido: item.tipo_documento.es_requerido,
            es_obligatorio: item.es_obligatorio !== undefined ? item.es_obligatorio : true,
            notas_requisitos: item.notas_requisitos || [],
          }));
        setRequisitosModalData(filteredDocs);
      }
    } catch (error) {
      console.error("❌ Error al obtener requisitos para modal:", error);
    } finally {
      setLoadingModalRequisitos(false);
    }
  }, [apiUrl, tipoPrestamo, requisitosModalData]);

  const handleVerDetalle = useCallback(async (fila) => {
    setLoading(true); // Empieza la carga

    const { id_preregistro } = fila;

    const { success, data, message } = await consumirApi({
      url: `${API_URL}/preregistros/${id_preregistro}/documentos`,
      method: "GET",
    });

    if (success && data?.data && data.data.length > 0) {
      // Usamos data.data porque el nuevo endpoint retorna { data: [...] }
      const documentos = data.data;
      setDetalleDocumento(documentos[0] || {}); // Primer elemento para info general
      setDetalleDocumento_sub(documentos); // Lista completa de documentos
      setRegistroSeleccionado(fila); // Solo abrimos el panel de detalle si la carga es exitosa
    } else {
      console.error("Error al obtener detalles o folio sin documentos:", message);
      setAlerta({
        tipo: "warning",
        mensaje: `El folio #${fila.folio} no cuenta con documentos asociados en el sistema debido a un inconveniente técnico. Por favor, contacte a soporte o inicie un nuevo trámite.`
      });
      setRegistroSeleccionado(null);
    }

    setLoading(false); // Termina la carga
  }, [API_URL]);

  const handleResubirDocumentosPorVencer = useCallback(async (evt) => {
    stopTour();

    const clickedTargetFolio = evt?.currentTarget?.getAttribute?.("data-target-folio");

    let selectedFolio = clickedTargetFolio;

    if (!selectedFolio) {
      const tramitePorVencer = rentasTramiteList?.find(item => {
        const est = item?.tramite_estatus?.toUpperCase()?.trim() || "";
        return est === "POR VENCER";
      });
      selectedFolio = tramitePorVencer?.folio_tramite || rentasTramiteInfo?.folio_tramite;
    }

    if (!selectedFolio) {
      setAlerta({ tipo: "error", mensaje: "No se encontró información del trámite de Rentas." });
      return;
    }

    const baseFolio = String(selectedFolio).endsWith('R')
      ? String(selectedFolio).slice(0, -1)
      : String(selectedFolio);

    setCargando(true);
    try {
      const resCambio = await consumirApi({
        url: `${API_URL}/preregistros/cambiar-estado`,
        method: "PUT",
        body: {
          usuario_codigo: numeroAfiliado,
          folio: baseFolio
        }
      });

      if (!resCambio.success) {
        throw new Error(resCambio.message || "Error al actualizar estado del preregistro");
      }

      console.log("[Rentas] Respuesta cambiar-estado exitosa:", resCambio);

      // Intentar extraer el id_preregistro del cuerpo de la respuesta de cambio de estado
      let preregistroId = null;
      if (resCambio.data) {
        const body = resCambio.data;
        if (body.id_preregistro) preregistroId = body.id_preregistro;
        else if (body.id) preregistroId = body.id;
        else if (body.data?.id_preregistro) preregistroId = body.data.id_preregistro;
        else if (body.data?.id) preregistroId = body.data.id;
        else if (body.resultado?.id_preregistro) preregistroId = body.resultado.id_preregistro;
        else if (body.resultado?.id) preregistroId = body.resultado.id;
      }

      // Si obtuvimos el ID directamente del PUT, avanzamos de inmediato sin depender de la lista
      if (preregistroId) {
        setIsResubiendoDocumentos(true);
        setId(preregistroId);
        setMostrarNuevoPrestamo(true);
        return;
      }

      // 1. Refrescar la lista de preregistros llamando a la API
      const { success, data: responseData } = await consumirApi({
        url: `${API_URL}/preregistros/listado/${userId}/${tipoPrestamo}`,
        method: "GET",
      });

      const rawData = responseData?.data || [];
      const data = rawData.map((item) => {
        if (item.nombre_estado === "Rechazado") {
          return {
            ...item,
            nombre_estado: item.tiene_bitacora ? "Rechazado" : "Observado",
          };
        }
        return item;
      });
      if (success && Array.isArray(data)) {
        setDatos(data);
        const docs = data.map((item) => ({
          id_preregistro: item.id_preregistro,
          nombre_estado: item.nombre_estado,
          fecha_preregistro: item.fecha_preregistro,
        }));
        setRequisitosDocumentos(docs);

        // 2. Buscar la fila actualizada que corresponde a nuestro baseFolio
        const cleanFolio = (f) => f ? String(f).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
        const cleanBaseFolio = cleanFolio(baseFolio);
        const cleanFolioTramite = cleanFolio(rentasTramiteInfo.folio_tramite);

        const filaActualizada = data.find(item => {
          const cleanItemFolio = cleanFolio(item.folio);
          return cleanItemFolio && (
            cleanItemFolio === cleanBaseFolio ||
            cleanItemFolio === cleanFolioTramite ||
            cleanFolioTramite.startsWith(cleanItemFolio) ||
            cleanItemFolio.startsWith(cleanBaseFolio)
          );
        });

        if (filaActualizada) {
          // 3. Pasar a la pantalla de subir documentos con el mismo ID de preregistro
          setIsResubiendoDocumentos(true);
          setId(filaActualizada.id_preregistro);
          setMostrarNuevoPrestamo(true);
        } else {
          setAlerta({
            tipo: "warning",
            mensaje: "Se actualizó el estado, pero no se encontró el folio del trámite en el listado."
          });
        }
      } else {
        setDatos([]);
        setAlerta({ tipo: "error", mensaje: "No se pudieron recargar los registros actualizados." });
      }
    } catch (err) {
      console.error("Error al preparar trámite para resubir documentos:", err);
      setAlerta({ tipo: "error", mensaje: err.message || "Ocurrió un error al preparar el trámite para resubir documentos." });
    } finally {
      setCargando(false);
    }
  }, [rentasTramiteInfo, API_URL, numeroAfiliado, userId, tipoPrestamo, consumirApi, setId, setIsResubiendoDocumentos]);

  // Mover fuera de Validador para evitar remounts innecesarios
  const CitaActionButton = ({ row, setOpenCalendarState, GetCitasDisponibles, apiUrlAgendador, Calendar, openCalendar, isMobile }) => {
    const [imprimiendo, setImprimiendo] = useState(false);
    const [showConfirmCancel, setShowConfirmCancel] = useState(false);
    const [alerta, setAlerta] = useState(null);
    const [esCitaPendiente, setEsCitaPendiente] = useState(false);

    useEffect(() => {
      const checkReserva = () => {
        const reservaGuardada = localStorage.getItem("reserva_cita");
        if (reservaGuardada) {
          try {
            const parsed = JSON.parse(reservaGuardada);
            if (parsed.folioPreregistro === row.original.folio && parsed.expiration > Date.now()) {
              setEsCitaPendiente(true);
              return;
            }
          } catch (e) {}
        }
        setEsCitaPendiente(false);
      };
      
      checkReserva();
      window.addEventListener("storage", checkReserva);
      const interval = setInterval(checkReserva, 2000);
      window.addEventListener("focus", checkReserva);

      return () => {
        window.removeEventListener("storage", checkReserva);
        window.removeEventListener("focus", checkReserva);
        clearInterval(interval);
      };
    }, [row.original.folio]);

    const estatusCita = row.original.estatus_cita;
    const folioCita = row.original.folio_cita;

    // Si el estatus es 7, la cita está cancelada definitivamente y no se permiten más acciones
    if (Number(estatusCita) === 7 || String(estatusCita).toUpperCase() === "CANCELADO") {
      return (
        <div className="flex items-center gap-2 px-4 py-2 bg-white text-red-700 rounded-xl border border-red-300">
          <FiXCircle className="size-4" />
          <span className="text-[10px] font-bold uppercase tracking-widest">Cita Cancelada</span>
        </div>
      );
    }

    // Si la fecha de la cita ya pasó, no mostrar acciones de cita (imprimir/cancelar)
    const fCitaStr = row.original.fecha_cita;
    if (fCitaStr) {
      const fCita = new Date(fCitaStr);
      if (!isNaN(fCita.getTime())) {
        const hoy = new Date();
        if (hoy > fCita) {
          return null;
        }
      }
    }

    const tieneCitaActiva = (row.original.cita_agendador === 1 || !!folioCita);

    const handleDescargar = async (e) => {
      e.stopPropagation();
      if (!folioCita) {
        setAlerta({ tipo: "warning", mensaje: "No se encontró el folio de la cita en este registro." });
        return;
      }

      setImprimiendo(true);
      try {
        const response = await fetch(`${apiUrlAgendador}/GenerarPDF`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            "codigo_afiliado": numeroAfiliado,
            "folio_cita": String(folioCita)
          })
        });

        if (response.ok) {
          const blob = await response.blob();
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = `Comprobante_Cita_${folioCita}.pdf`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          setTimeout(() => {
            window.URL.revokeObjectURL(downloadUrl);
          }, 1000);
        } else {
          setAlerta({ tipo: "error", mensaje: "Error al generar el comprobante PDF." });
        }
      } catch (e) {
        console.error(e);
        setAlerta({ tipo: "error", mensaje: "Error de conexión al servidor de documentos." });
      } finally {
        setImprimiendo(false);
      }
    };

    const handleCancelar = async () => {
      if (!row.original.id_cita && !row.original.folio_cita) {
        setAlerta({ tipo: "error", mensaje: "No se encontró información de la cita para cancelar." });
        return;
      }

      try {
        const codigoLimpio = (typeof numeroAfiliado === "string" && numeroAfiliado.startsWith("deudo-"))
          ? (numeroAfiliado.split("-")[1] || numeroAfiliado)
          : numeroAfiliado;

        const response = await fetch(`${apiUrlAgendador}/cancelarCita`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            "codigo_afiliado": String(codigoLimpio),
            "folio_cita": parseInt(row.original.folio_cita)
          })
        });

        if (!response.ok) {
          const textError = await response.text();
          console.error("Error del servidor (no OK):", textError);
          setAlerta({ tipo: "error", mensaje: `Error ${response.status}: El servidor de citas no encontró el endpoint.` });
          return;
        }

        const resData = await response.json();

        if (resData.success === 1) {
          const folio = row.original.folio;
          if (folio) {
            try {
              await fetch(`${process.env.REACT_APP_API_URL}/cambiaEstatusCita/${folio}`, {
                method: "GET",
              });
            } catch (err) {
              console.error("Error al actualizar estatus local:", err);
            }
          }

          setAlerta({ tipo: "success", mensaje: resData.message || "Cita cancelada correctamente" });
          validar();
        } else {
          setAlerta({ tipo: "error", mensaje: resData.message || "Error al cancelar la cita." });
        }
      } catch (error) {
        console.error("Error al cancelar cita:", error);
        setAlerta({ tipo: "error", mensaje: "Error de conexión al intentar cancelar la cita." });
      }
    };

    if (tieneCitaActiva) {
      return (
        <div className={twMerge(isMobile ? "w-full flex flex-col gap-2" : "flex items-center gap-2")}>
          <button
            onClick={handleDescargar}
            disabled={imprimiendo}
            className={twMerge(
              "inline-flex items-center justify-center gap-2 px-4 h-10 bg-white text-blue-700 hover:bg-blue-50 border border-blue-300 hover:border-blue-400 rounded-xl text-xs sm:text-[13px] font-bold tracking-normal transition-all duration-200 whitespace-nowrap active:scale-95 shadow-xs",
              isMobile && "w-full h-12 rounded-2xl text-sm",
              imprimiendo && "opacity-70 cursor-not-allowed scale-95"
            )}
          >
            {imprimiendo ? <FiClock className="size-4 animate-spin shrink-0" /> : <FiPrinter className="size-4 shrink-0" />}
            <span>{imprimiendo ? "Imprimiendo..." : "Imprimir Cita"}</span>
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); setShowConfirmCancel(true); }}
            className={twMerge(
              "inline-flex items-center justify-center gap-2 px-4 h-10 bg-white text-rose-600 hover:bg-rose-50 border border-rose-300 hover:border-rose-400 rounded-xl text-xs sm:text-[13px] font-bold tracking-normal transition-all duration-200 whitespace-nowrap active:scale-95 shadow-xs",
              isMobile && "w-full h-12 rounded-2xl text-sm"
            )}
          >
            <FiX className="size-4 shrink-0" />
            <span>Cancelar Cita</span>
          </button>

          <ModalConfirmacion
            isOpen={showConfirmCancel}
            onClose={() => setShowConfirmCancel(false)}
            onConfirm={handleCancelar}
            titulo="Cancelar Cita"
            mensaje="¿Estás seguro de que deseas cancelar esta cita? Esta acción no se puede deshacer."
            textoConfirmar="Sí, cancelar cita"
            textoCancelar="No, mantener cita"
            tipo="danger"
          />

          <AnimatePresence>
            {alerta && (
              <Alerta
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                onClose={() => setAlerta(null)}
              />
            )}
          </AnimatePresence>
        </div>
      );
    }

    return (
      <div className={twMerge(isMobile ? "w-full flex flex-col gap-2" : "flex items-center gap-2")}>
        {Number(row.original.estatus_cita) === 7 || String(row.original.estatus_cita).toUpperCase() === "CANCELADO" ? (
          <span className={twMerge(
            "flex items-center justify-center px-4 h-10 bg-white text-rose-600 rounded-xl text-xs sm:text-[13px] font-bold border border-rose-300 whitespace-nowrap",
            isMobile && "w-full h-12 rounded-2xl text-sm"
          )}>
            Cita Cancelada
          </span>
        ) : (
          <>
            <button
              onClick={() => { setOpenCalendarState(row.original.folio); GetCitasDisponibles(); }}
              data-tour={isMobile ? "agendar-cita-btn-movil" : "agendar-cita-btn"}
              data-folio={row.original.folio}
              className={twMerge(
                "inline-flex items-center justify-center gap-2 px-4 h-10 rounded-xl text-xs sm:text-[13px] font-bold tracking-normal transition-all duration-200 whitespace-nowrap active:scale-95 shadow-sm",
                isMobile && "w-full h-12 rounded-2xl text-sm",
                esCitaPendiente 
                  ? "bg-amber-500 text-white hover:bg-amber-600 shadow-amber-500/20 animate-pulse" 
                  : "bg-emerald-600 text-white hover:bg-emerald-700 shadow-emerald-600/10"
              )}
            >
              {esCitaPendiente ? <FiClock className="size-4 shrink-0" /> : <FiCalendar className="size-4 shrink-0" />}
              <span>{esCitaPendiente ? "Continuar Cita" : "Agendar Cita"}</span>
            </button>
            <AnimatePresence>
              {openCalendar === row.original.folio && (
                <Calendar
                  onClose={() => setOpenCalendarState(null)}
                  folioPreregistro={row.original.folio}
                  onCitaConfirmada={(folioReal, fechaCitaFormat) => {
                    setDatos((prevDatos) =>
                      prevDatos.map((item) => {
                        if (item.folio === row.original.folio) {
                          return {
                            ...item,
                            cita_agendador: 1,
                            folio_cita: String(folioReal),
                            fecha_cita: fechaCitaFormat,
                            estatus_cita: 1
                          };
                        }
                        return item;
                      })
                    );
                  }}
                />
              )}
            </AnimatePresence>
          </>
        )}
      </div>
    );
  };

  const columns = React.useMemo(() => [
    {
      id: "select",
    },
    {
      id: "acciones",
      header: "Acciones",
      cell: ({ row }) => {
        const estatus = row.getValue("nombre_estado") || row.original?.nombre_estado || "";
        const folioVal = row.getValue("folio") || row.original?.folio;
        const estatusRentas = (tipoPrestamo?.toLowerCase() === "rentas" ? obtenerEstatusRentasPorFolio(folioVal) : "")?.toUpperCase()?.trim() || "";
        const isVencidoOConcluido = estatusRentas === "VENCIDO" || estatusRentas === "CONCLUIDO" || estatusRentas === "CONCLUIDA";
        const esObservado = !isVencidoOConcluido && (["Observado", "Con Observaciones", "Rechazado"].includes(estatus) || estatus.toUpperCase() === "OBSERVADO");

        return (
          <div className="flex items-center gap-2">
            <button
              onClick={() => handleVerDetalle(row.original)}
              data-tour={row.index === 0 ? "abrir-detalle-btn" : undefined}
              className={twMerge(
                "inline-flex items-center justify-center gap-2 px-4 h-10 rounded-xl text-xs sm:text-[13px] font-bold tracking-normal transition-all duration-200 active:scale-95 shadow-sm whitespace-nowrap",
                esObservado
                  ? "bg-primary hover:bg-primary/90 text-white shadow-primary/20"
                  : "bg-white hover:bg-slate-50 text-slate-700 hover:text-primary border border-slate-300 hover:border-primary/40 shadow-xs"
              )}
            >
              {esObservado ? <FiUploadCloud className="size-4 text-white" /> : <FiFileText className="size-4 text-slate-400" />}
              <span>{esObservado ? "Corregir Documento" : "Ver Detalle"}</span>
            </button>

            {estatus === "Aprobado" && (
              <CitaActionButton
                row={row}
                email={userEmail}
                setOpenCalendarState={setOpenCalendar}
                GetCitasDisponibles={GetCitasDisponibles}
                apiUrl={apiUrl}
                apiUrlAgendador={apiUrl_agendador}
                Calendar={Calendar}
                openCalendar={openCalendar}
                isMobile={false}
              />
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "id_preregistro",
      header: "ID",
      cell: ({ row }) => (
        <div className="text-center">{row.getValue("id_preregistro")}</div>
      ),
    },
    {
      accessorKey: "folio",
      header: "Folio",
      filterFn: (row, id, filterValue) => {
        const rowValue = row.getValue(id);
        if (rowValue === undefined || rowValue === null) return false;
        // Convertimos número a string para buscar substring
        return rowValue.toString().includes(filterValue);
      },
      cell: ({ row }) => <div className="text-center">{row.getValue("folio")}</div>,
    },
    {
      accessorKey: "nombre_estado",
      header: "Estatus",
      cell: ({ row }) => {
        const value = row.getValue("nombre_estado");
        const displayText = value;

        let statusStyles = "inline-flex items-center px-3 py-1 rounded-lg text-[11px] font-bold uppercase tracking-widest ";
        if (value === "Aprobado") {
          statusStyles += "bg-white text-green-700 border border-green-300";
        } else if (value === "Rechazado" || value === "Preregistro Rechazado" || value === "Observado") {
          statusStyles += "bg-white text-red-600 border border-red-300";
        } else if (value === "Pendiente") {
          statusStyles += "bg-white text-amber-700 border border-amber-300";
        } else {
          statusStyles += "bg-white text-slate-600 border border-slate-300";
        }

        return (
          <div className="flex justify-center">
            {tipoPrestamo?.toLowerCase() === "rentas" && value === 'Aprobado' ? (
              <div className="size-6 rounded-full bg-emerald-500 text-white flex items-center justify-center shadow-xs" title="Aprobado">
                <FiCheck className="size-3.5 stroke-[3]" />
              </div>
            ) : tipoPrestamo?.toLowerCase() === "rentas" && value?.toLowerCase() === 'cancelado' ? (
              <div className="size-6 rounded-full bg-slate-400 text-white flex items-center justify-center shadow-xs" title="Cancelado">
                <svg className="size-3 stroke-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                </svg>
              </div>
            ) : (
              <span
                data-tour={row.index === 0 ? "estatus-folio-badge" : undefined}
                className={statusStyles}
              >
                {displayText}
              </span>
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "folio_cita",
      header: tipoPrestamo?.toLowerCase() === "rentas" ? "Folio fila virtual" : "Folio Cita",
      cell: ({ row }) => {
        const isRentas = tipoPrestamo?.toLowerCase() === "rentas";
        const val = isRentas
          ? (hideFolioAndFecha ? "-" : obtenerFolioFilaVirtual(row.original.folio))
          : (row.getValue("folio_cita") || "-");
        
        if (val === "SIN INICIAR") {
          return (
            <div className="text-center text-slate-400 italic font-bold text-[10px]">
              SIN INICIAR
            </div>
          );
        }

        return (
          <div className="text-center font-bold text-blue-600">
            {val}
          </div>
        );
      },
    },
    {
      accessorKey: "fecha_cita",
      header: tipoPrestamo?.toLowerCase() === "rentas" ? "Fecha" : "Fecha Cita",
      cell: ({ row }) => {
        const isRentas = tipoPrestamo?.toLowerCase() === "rentas";
        const fecha = isRentas 
          ? (hideFolioAndFecha ? null : row.original.fecha_preregistro) 
          : row.getValue("fecha_cita");
        if (!fecha) return <div className="text-center">-</div>;

        try {
          const dateObj = new Date(fecha);
          const formattedDate = dateObj.toLocaleDateString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          });
          return <div className="text-center whitespace-nowrap">{formattedDate}</div>;
        } catch (e) {
          return <div className="text-center">{fecha}</div>;
        }
      },
    }

  ], [userEmail, openCalendar, apiUrl, apiUrl_agendador, GetCitasDisponibles, handleVerDetalle, tipoPrestamo, hideFolioAndFecha, handleIniciarTramite, rentasTramiteInfo, rentasTramiteList]);

  const table = useReactTable({
    data: datos,
    columns,
    state: {
      sorting,
      columnFilters,
      columnVisibility,
      rowSelection, globalFilter,
    },
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onRowSelectionChange: setRowSelection,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(), onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: (row, columnId, filterValue) => {
      const filter = filterValue.toLowerCase();

      const nombre_estado = row.getValue("nombre_estado")?.toString().toLowerCase() ?? "";
      const folio = row.getValue("folio")?.toString() ?? "";

      return nombre_estado.includes(filter) || folio.includes(filter);
    },
  });


  useEffect(() => {
    const obtenerDocumentosSubidos = async () => {
      if (!id) return;
      try {
        const { success, data, message } = await consumirApi({
          url: `${apiUrl}/preregistros/${id}/documentos`,
          method: "GET",
        });

        if (success && data?.data) {
          const requisitosSubidos = data.data.map((doc) => doc.requisito_id);
          setDocumentosYaSubidos(requisitosSubidos);
        } else {
          console.error("Error en la respuesta:", message);
        }
      } catch (error) {
        console.error("Error al obtener documentos ya subidos:", error);
      }
    };
    obtenerDocumentosSubidos();
  }, [id, apiUrl]);

  // Validar estado permitido solo al cambiar datos o información de rentas
  useEffect(() => {
    if (!datos) return;

    const isRentas = tipoPrestamo?.toLowerCase() === "rentas";
    const puedeIniciar = datos.length === 0 || datos.every(item =>
      (item.nombre_estado === "Aprobado" && (
        (
          (item.cita_agendador === 1 || item.es_cita_agendada === true || !!item.folio_cita) &&
          (item.folio_cita && item.folio_cita !== "-") &&
          (item.fecha_cita && item.fecha_cita !== "-")
        ) ||
        Number(item.estatus_cita) === 7 ||
        String(item.estatus_cita).toUpperCase() === "CANCELADO"
      )) ||
      item.nombre_estado === "Preregistro Rechazado" ||
      item.nombre_estado === "Rechazado" ||
      item.nombre_estado === "Observado" ||
      (isRentas && item.nombre_estado?.toLowerCase() === "cancelado")
    );

    const listRentas = rentasTramiteList && rentasTramiteList.length > 0
      ? rentasTramiteList
      : (rentasTramiteInfo ? [rentasTramiteInfo] : []);

    const permiteNuevoPorEstatus = isRentas && listRentas.some(item => {
      const est = item?.tramite_estatus?.toUpperCase()?.trim() || "";
      return est === "VENCIDO" || est === "CANCELADO" || est === "CONCLUIDO" || est === "POR VENCER";
    });

    setEstadoPermitido(puedeIniciar || permiteNuevoPorEstatus);
  }, [datos, tipoPrestamo, rentasTramiteInfo, rentasTramiteList]);






  // Ejemplo: llamamos la función al montar el componente
  useEffect(() => {
    if (tipoPrestamo?.toLowerCase() !== "rentas") {
      GetCitasDisponibles();
    }
  }, [GetCitasDisponibles, tipoPrestamo]);

  const handleStartTour = (force = true) => {
    const steps = [];

    if (mostrarNuevoPrestamo) {
      // STEPER SCREEN TOUR (Carga de documentos)
      const indicadorPartes = document.querySelector('[data-tour="indicador-partes"]');
      if (indicadorPartes) {
        steps.push({
          target: "indicador-partes",
          title: "Parte a Subir",
          description: "Aquí te indica qué parte del documento debes subir (ej. Frente o Reverso).",
          position: "bottom"
        });
      }

      const fileUpload = document.querySelector('[data-tour="file-upload-section"]');
      if (fileUpload) {
        steps.push({
          target: "file-upload-section",
          title: "Subir Archivo",
          description: "Presiona este cuadro para seleccionar y subir el archivo de la parte solicitada.",
          position: "top"
        });
      }

      const isMobile = window.innerWidth < 1024;
      if (isMobile) {
        const btnMovil = document.querySelector('[data-tour="indicaciones-btn-movil"]');
        if (btnMovil) {
          steps.push({
            target: "indicaciones-btn-movil",
            title: "Indicaciones del Requisito",
            description: "Revisa con atención las indicaciones y notas específicas para este documento antes de subirlo.",
            position: "bottom"
          });
        }
      } else {
        const panelDesktop = document.querySelector('[data-tour="indicaciones-panel-desktop"]');
        if (panelDesktop) {
          steps.push({
            target: "indicaciones-panel-desktop",
            title: "Indicaciones del Requisito",
            description: "Aquí puedes ver las indicaciones y notas importantes específicas para este documento.",
            position: "left"
          });
        }
      }

      const btnComp = document.querySelector('[data-tour="btn-complementaria"]');
      if (btnComp) {
        steps.push({
          target: "btn-complementaria",
          title: "Documentos Extras (Opcional)",
          description: "Presiona este botón si necesitas adjuntar algún comprobante o papel adicional.",
          position: "top"
        });
      }

      const btnSiguiente = document.querySelector('[data-tour="stepper-siguiente-btn"]');
      if (btnSiguiente) {
        steps.push({
          target: "stepper-siguiente-btn",
          title: "Avanzar",
          description: "Presiona aquí para pasar al siguiente documento. Se activará cuando subas tu archivo.",
          position: "top"
        });
      }
    } else if (document.querySelector('[data-tour="detalle-panel-header"]')) {
      // DETALLE VIEW TOUR
      steps.push({
        target: "detalle-panel-header",
        title: "Detalles del Registro",
        description: "Aquí puedes ver la información de tu trámite, fecha de registro y su estatus actual.",
        position: "bottom"
      });

      const obsBox = document.querySelector('[data-tour="observacion-general-box"]');
      if (obsBox) {
        steps.push({
          target: "observacion-general-box",
          title: "Notas del Validador",
          description: "Si tu trámite tiene observaciones, lee esta sección para saber qué debes corregir.",
          position: "top"
        });
      }

      const obsBtn = document.querySelector('[data-tour="documento-observado-btn"]');
      if (obsBtn) {
        steps.push({
          target: "documento-observado-btn",
          title: "Documento Observado",
          description: "Presiona este círculo rojo para ver la observación específica de este documento y volverlo a subir.",
          position: "top"
        });
      }
    } else {
      // LIST SCREEN TOUR
      steps.push({
        target: "nombre-modulo",
        title: "Sección de tu Trámite",
        description: tipoPrestamo?.toLowerCase() === "rentas"
          ? "Aquí puedes ver tus solicitudes, subir documentos y seleccionar inmuebles."
          : "Aquí puedes ver tus solicitudes, subir documentos y agendar tu cita.",
        position: "bottom"
      });

      const btnIniciar = document.querySelector('[data-tour="iniciar-tramite-btn"]');
      const isBtnIniciarVisible = btnIniciar && !btnIniciar.classList.contains("hidden") && (btnIniciar.offsetParent !== null || btnIniciar.offsetWidth > 0 || btnIniciar.offsetHeight > 0);
      if (mostrarBtnIniciarTramite && isBtnIniciarVisible) {
        steps.push({
          target: "iniciar-tramite-btn",
          title: "Iniciar Trámite",
          description: "Presiona este botón para comenzar a subir tus documentos.",
          position: "bottom"
        });
      }

      const isMobile = window.innerWidth < 768;
      const badgeSelector = isMobile ? "estatus-folio-badge-movil" : "estatus-folio-badge";
      const abrirSelector = isMobile ? "abrir-detalle-btn-movil" : "abrir-detalle-btn";
      const citaSelector = isMobile ? "agendar-cita-btn-movil" : "agendar-cita-btn";
      const inmueblesSelector = isMobile ? "seleccionar-inmuebles-btn-movil" : "seleccionar-inmuebles-btn";

      const estatusBadge = document.querySelector(`[data-tour="${badgeSelector}"]`);
      if (estatusBadge) {
        steps.push({
          target: badgeSelector,
          title: "Estado de tu Trámite",
          description: "Muestra si tu solicitud está Pendiente, Aprobada o tiene observaciones.",
          position: isMobile ? "top" : "bottom"
        });
      }

      const btnAbrir = document.querySelector(`[data-tour="${abrirSelector}"]`);
      if (btnAbrir) {
        steps.push({
          target: abrirSelector,
          title: "Ver Detalle",
          description: "Presiona aquí para ver el avance de tu trámite o corregir documentos.",
          position: isMobile ? "top" : "bottom"
        });
      }

      const isRentas = tipoPrestamo?.toLowerCase() === "rentas";
      if (isRentas) {
        const btnInmuebles = document.querySelector(`[data-tour="${inmueblesSelector}"]`);
        if (btnInmuebles) {
          steps.push({
            target: inmueblesSelector,
            title: "Seleccionar Inmuebles",
            description: "Una vez aprobado tu trámite, presiona aquí para seleccionar tus conjuntos habitacionales de interés en el mapa.",
            position: isMobile ? "top" : "left"
          });
        }
      } else {
        const btnCita = document.querySelector(`[data-tour="${citaSelector}"]`);
        if (btnCita) {
          steps.push({
            target: citaSelector,
            title: "Agendar Cita",
            description: "Una vez aprobado tu trámite, presiona aquí para elegir el día y hora de tu cita.",
            position: isMobile ? "top" : "left"
          });
        }
      }
    }

    const activeKey = mostrarNuevoPrestamo 
      ? "tour-validador-stepper" 
      : (document.querySelector('[data-tour="detalle-panel-header"]') 
        ? "tour-validador-detail" 
        : "tour-validador-list");

    const tourJSON = {
      steps,
      options: {
        persistKey: activeKey,
        showProgress: true,
        allowClose: true,
        doneBtnText: "Entendido",
        nextBtnText: "Siguiente Paso",
        prevBtnText: "Volver Atrás"
      }
    };

    try {
      startTour(tourJSON, force);
    } catch (error) {
      console.error("Error al iniciar el tour en Validador:", error);
    }
  };

  // Auto-start Stepper Tour
  useEffect(() => {
    if (mostrarNuevoPrestamo && requisitosDocumentos.length > 0) {
      if (!tourAttempted.current.stepper) {
        tourAttempted.current.stepper = true;
        const isCompleted = localStorage.getItem("tour-validador-stepper");
        if (isCompleted !== "completed") {
          const timer = setTimeout(() => {
            handleStartTour(false);
          }, 800);
          return () => clearTimeout(timer);
        }
      }
    } else if (!mostrarNuevoPrestamo) {
      tourAttempted.current.stepper = false;
    }
  }, [mostrarNuevoPrestamo, requisitosDocumentos]);

  // Auto-start Detail Tour
  useEffect(() => {
    if (registroSeleccionado) {
      if (!tourAttempted.current.detail) {
        tourAttempted.current.detail = true;
        const isCompleted = localStorage.getItem("tour-validador-detail");
        if (isCompleted !== "completed") {
          const timer = setTimeout(() => {
            handleStartTour(false);
          }, 800);
          return () => clearTimeout(timer);
        }
      }
    } else {
      tourAttempted.current.detail = false;
    }
  }, [registroSeleccionado]);

  // Auto-start List Tour
  useEffect(() => {
    if (!cargando && !mostrarNuevoPrestamo && !registroSeleccionado && !isIntroModalOpen) {
      if (!tourAttempted.current.list) {
        tourAttempted.current.list = true;
        const isCompleted = localStorage.getItem("tour-validador-list");
        if (isCompleted !== "completed") {
          const timer = setTimeout(() => {
            handleStartTour(false);
          }, 800);
          return () => clearTimeout(timer);
        }
      }
    } else {
      if (isIntroModalOpen) {
        tourAttempted.current.list = false;
      } else if (cargando || mostrarNuevoPrestamo || registroSeleccionado) {
        tourAttempted.current.list = false;
      }
    }
  }, [cargando, mostrarNuevoPrestamo, registroSeleccionado, isIntroModalOpen]);

  if (cargandoSedes) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[300px] p-8">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4"></div>
        <p className="text-slate-500 font-medium animate-pulse text-sm">Consultando sedes disponibles...</p>
      </div>
    );
  }

  if (!idSede && sedesList.length > 1) {
    return (
      <div className="p-6 md:p-12 max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-primary/10 text-primary mb-3">
            <FiMapPin className="size-3.5" /> Selección de Sede
          </span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-800 tracking-tight">
            ¿En qué sede deseas realizar tu trámite?
          </h2>
          <p className="text-slate-500 mt-2 text-sm md:text-base max-w-md mx-auto">
            Este trámite está disponible en múltiples oficinas. Por favor selecciona la más cercana o conveniente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {sedesList.map((sede) => (
            <button
              key={sede.id_sede}
              onClick={() => {
                const idSedeStr = String(sede.id_sede);
                setIdSede(idSedeStr);
                localStorage.setItem("id_sede", idSedeStr);
              }}
              className="flex flex-col text-left p-6 bg-white border border-slate-200 rounded-2xl hover:border-primary hover:shadow-lg hover:shadow-primary/5 transition-all duration-300 group cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/20 w-full"
            >
              <div className="flex items-start gap-4 w-full">
                <div className="p-3 rounded-xl bg-slate-50 text-slate-600 group-hover:bg-primary/10 group-hover:text-primary transition-colors duration-300">
                  <FiMapPin className="size-6" />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-slate-800 group-hover:text-primary transition-colors duration-300 text-lg">
                    {sede.alias || sede.descripcion || `Sede ${sede.id_sede}`}
                  </h3>
                  {sede.descripcion && (
                    <p className="text-xs text-slate-400 mt-0.5 uppercase tracking-wider font-semibold">
                      {sede.descripcion}
                    </p>
                  )}
                  {sede.domicilio && (
                    <p className="text-sm text-slate-600 mt-3 flex items-start gap-2 leading-relaxed">
                      <span>{sede.domicilio}</span>
                    </p>
                  )}
                  {(sede.colonia || sede.municipio) && (
                    <p className="text-xs text-slate-500 mt-1 italic">
                      {[sede.colonia, sede.municipio].filter(Boolean).join(", ")}
                    </p>
                  )}
                  {sede.telefono && (
                    <p className="text-xs text-slate-500 mt-2 flex items-center gap-1.5 font-medium">
                      <span>Teléfono: {sede.telefono}</span>
                    </p>
                  )}
                </div>
              </div>
              <div className="mt-5 w-full flex items-center justify-end text-sm font-semibold text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300 gap-1">
                <span>Seleccionar sede</span>
                <FiChevronRight className="size-4" />
              </div>
            </button>
          ))}
        </div>
      </div>
    );
  }

  // Pantalla completa de Cita de Continuidad Vigente (id_catalogo_tramite == 4)
  if (mostrarVistaContinuidad && citaContinuidadData) {
    return (
      <div className="w-full bg-white relative">
        <DetalleCitaContinuidad
          cita={citaContinuidadData}
          codigoAfiliado={citaContinuidadData.codigo_afiliado || numeroAfiliado || userId}
          apiUrlAgendador={apiUrl_agendador}
          apiKeyCitas={apiKeyCitas}
          onVerHistorial={() => setMostrarVistaContinuidad(false)}
          onAlerta={(alertaObj) => setAlerta(alertaObj)}
        />
        <FullLoaderTramite visible={mostrarFullLoader4s} nombreTramite={nombreLargo} />
        {alerta && (
          <Alerta
            tipo={alerta.tipo}
            mensaje={alerta.mensaje}
            titulo={alerta.titulo}
            duration={alerta.duration}
            onClose={() => setAlerta(null)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="bg-white group overflow-hidden">
      {/* Panel bloqueante de Rentas */}
      {rentasBloqueo && (
        <div className="p-6 md:p-16 flex flex-col items-center text-center">
          <div className={`size-20 md:size-24 rounded-full flex items-center justify-center mb-6 border-2 ${
            rentasBloqueo.tipo === "plaza" ? "bg-white border-amber-500 text-amber-500" :
            rentasBloqueo.tipo === "ph" ? "bg-white border-red-500 text-red-500" : "bg-white border-gray-400 text-gray-400"
          }`}>
            {rentasBloqueo.tipo === "plaza" ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="size-10 md:size-12 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
              </svg>
            ) : rentasBloqueo.tipo === "ph" ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="size-10 md:size-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="size-10 md:size-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
              </svg>
            )}
          </div>

          <h2 className={`text-xl md:text-2xl font-extrabold tracking-tight mb-3 ${
            rentasBloqueo.tipo === "plaza" ? "text-amber-700" :
            rentasBloqueo.tipo === "ph" ? "text-red-700" : "text-gray-800"
          }`}>
            {rentasBloqueo.titulo}
          </h2>

          <p className="text-sm md:text-base text-gray-600 leading-relaxed max-w-lg mb-4">
            {rentasBloqueo.mensaje}
          </p>

          {rentasBloqueo.detalle && (
            <div className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs font-bold uppercase tracking-widest mb-6 ${
              rentasBloqueo.tipo === "plaza" ? "bg-white text-amber-700 border border-amber-300" :
              rentasBloqueo.tipo === "ph" ? "bg-white text-red-700 border border-red-300" : "bg-white text-gray-700 border border-gray-300"
            }`}>
              {rentasBloqueo.detalle}
            </div>
          )}

          <div className="mt-4 p-4 bg-white rounded-2xl border border-blue-300 max-w-md">
            <p className="text-xs text-blue-700 font-medium leading-relaxed">
              <strong>¿Necesita ayuda?</strong> Si considera que esta información es incorrecta, acuda a las oficinas de IPEJAL o contacte al área de atención al afiliado para recibir asistencia.
            </p>
          </div>

          <button
            onClick={() => setRentasBloqueo(null)}
            className="mt-8 px-8 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-2xl font-bold text-xs uppercase tracking-widest transition-all active:scale-95"
          >
            Cerrar
          </button>
        </div>
      )}

      {!rentasBloqueo && (
        <AnimatePresence mode="wait">
          {cargando ? (
            <motion.div
              key="loader-sincronizar"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="p-20 flex flex-col items-center gap-4 bg-slate-50/30"
            >
              <FiClock className="size-10 text-primary animate-spin" />
              <p className="text-gray-400 font-bold uppercase tracking-widest text-[10px]">Sincronizando trámites...</p>
            </motion.div>
          ) : mostrarNuevoPrestamo ? (
            cargandoRequisitos ? (
              <motion.div
                key="loader-requisitos"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="w-full mx-auto p-4 md:p-10 max-w-5xl"
              >
                <SkeletonRequisitos />
              </motion.div>
            ) : (
              <motion.div
                key="stepper-requisitos"
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -15 }}
                transition={{ duration: 0.3 }}
                className="w-full mx-auto p-4 md:p-10 flex flex-col lg:flex-row gap-6 items-start relative overflow-hidden"
              >
          <div className="flex-1 w-full">
            <div className="flex items-center justify-between mb-6 border-b border-slate-100 pb-4">
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-[10px] font-bold bg-primary/10 text-primary px-3 py-1.5 rounded-xl uppercase tracking-wider">Carga de Requisitos</span>
              <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">Folio: #{id}</span>
              {sedeName && (
                <div className="inline-flex items-center gap-1.5 bg-slate-50 border border-slate-200 rounded-xl px-2.5 py-1 text-slate-600 text-[10px] font-medium leading-none shadow-sm">
                  <FiMapPin className="size-3.5 text-slate-400" />
                  <span>Sede: <strong className="text-slate-800 font-bold">{sedeName}</strong></span>
                  {sedesList.length > 1 && puedeCambiarSede && (
                    <>
                      <span className="w-[1px] h-3 bg-slate-200 mx-1" />
                      <button
                        type="button"
                        onClick={() => {
                          setIdSede(null);
                          localStorage.removeItem("id_sede");
                        }}
                        className="text-[9px] font-extrabold text-primary hover:underline uppercase tracking-wider transition-colors cursor-pointer focus:outline-none"
                      >
                        Cambiar
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
            <button
              onClick={handleStartTour}
              className="flex items-center justify-center gap-1.5 px-3 py-1.5 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl text-primary font-extrabold text-[10px] uppercase tracking-wider shadow-sm active:scale-95 transition-all"
            >
              <FiHelpCircle className="size-3.5" />
              <span>Ver Guía</span>
            </button>
          </div>

          {/* Botón de indicaciones para móvil, abre pantalla completa */}
          {tieneNotasActivas && (
            <div className="lg:hidden flex justify-center mb-6">
              <button
                type="button"
                data-tour="indicaciones-btn-movil"
                onClick={() => setOpenMobileNotas(true)}
                className="w-full flex items-center justify-center gap-2 py-3 bg-primary hover:bg-primary/95 text-white rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 shadow-md shadow-primary/10"
              >
                <FiAlertCircle className="size-4.5 text-white animate-pulse" />
                <span>Ver Indicaciones / Notas ({documentoActual?.notas_requisitos?.filter(n => n.es_activo).length})</span>
              </button>
            </div>
          )}
          {(requisitosDocumentos.length === 0 && !omitirValidacion) ? (
            <div className="py-20 text-center bg-red-50 rounded-[2.5rem] border-2 border-dashed border-red-100 flex flex-col items-center gap-4">
              <FiX className="size-10 text-red-400" />
              <p className="text-red-500 font-bold tracking-tight uppercase max-w-xs mx-auto text-sm">
                Este tipo de préstamo aún no tiene requisitos configurados.
              </p>
              <button
                onClick={() => {
                  stopTour(); // Cierra el tour si estaba activo en el stepper
                  setMostrarNuevoPrestamo(false);
                }}
                className="mt-4 px-6 py-3 bg-red-100 text-red-600 rounded-2xl font-bold text-[10px] uppercase tracking-widest hover:bg-red-200 transition-all"
              >
                Volver
              </button>
            </div>
          ) : (
            <Stepper
              key={id || "stepper"}
              initialStep={omitirValidacion ? requisitosDocumentos.length + 1 : 1}
              numero={id}
              disableStepIndicators={true}
              onStepChange={setCurrentStep}
              onFinalStepCompleted={async () => {
                stopTour(); // Cierra el tour si estaba activo al finalizar el preregistro

                const isRentas = tipoPrestamo?.toLowerCase() === "rentas";
                const estatusStr = rentasTramiteInfo?.tramite_estatus?.toUpperCase()?.trim() || "";
                const isPorVencer = estatusStr === "POR VENCER";

                console.log("[Rentas - debug]", {
                  isRentas,
                  isPorVencer,
                  isResubiendoDocumentos,
                  rentasTramiteInfo,
                  id
                });

                let rentasStatusSuccess = false;
                if (isRentas) {
                  const rentasApiUrl = apiUrlRentas || process.env.REACT_APP_API_URL_RENTAS;
                  
                  // Obtener el estatus del último trámite en Rentas
                  const estatusUltimoTramite = rentasTramiteInfo?.tramite_estatus?.toUpperCase()?.trim() || "";
                  const esAprobado = estatusUltimoTramite === "APROBADO";
                  const esPorVencer = estatusUltimoTramite === "POR VENCER";
                  
                  // Obtener folio virtual (debe estar en Rentas)
                  const rawFolio = rentasTramiteInfo?.folio_tramite || 
                                   rentasTramiteList?.find(item => item?.folio_tramite)?.folio_tramite || null;

                  console.log("[Rentas] Evaluando si se asigna estatus 3:", {
                    estatusUltimoTramite,
                    esAprobado,
                    esPorVencer,
                    rawFolio
                  });

                  if ((esAprobado || esPorVencer) && rawFolio) {
                    const folio = String(rawFolio).endsWith('R') ? String(rawFolio) : `${rawFolio}R`;
                    console.log("[Rentas - fetch asignando estatus 3]", { rentasApiUrl, folio });
                    if (rentasApiUrl) {
                      try {
                        const resEstatus = await fetch(`${rentasApiUrl}/tramite_asignar_estatus/3/${folio}`);
                        console.log("[Rentas - response status]", resEstatus.status, resEstatus.ok);
                        if (resEstatus.ok) {
                          console.log("[Rentas] Estatus asignado con éxito a 3 (GET)");
                          rentasStatusSuccess = true;
                        } else {
                          console.error("[Rentas] Error al asignar estatus 3 (GET):", resEstatus.statusText);
                        }
                      } catch (e) {
                        console.error("[Rentas] Error al llamar tramite_asignar_estatus:", e);
                      }
                    }
                  } else {
                    console.log("[Rentas] No se cumple condición para asignar estatus 3 (debe ser APROBADO o POR VENCER y tener folio virtual)");
                  }
                }

                setMostrarNuevoPrestamo(false);
                setEstadoPermitido(false);
                await new Promise(r => setTimeout(r, 100));
                
                // 1. Refrescar listado de preregistros primero
                await validar();
                
                // 2. Refrescar datos de Rentas desde la API (para actualizar la lista y la vista)
                await fetchRentasTramiteInfo();
              }}
              nextButtonDisabled={!puedeAvanzarPasoActual}
              setMostrarNuevoPrestamo={setMostrarNuevoPrestamo}
              nextButtonHint={(() => {
                const index = currentStep - 1;
                const doc = requisitosDocumentos[index];
                if (doc && doc.es_obligatorio === false && (!documentosYaSubidos.includes(doc.pre) || isResubiendoDocumentos)) {
                  return "Puedes omitir este paso";
                }
                return null;
              })()}
              leftAction={(() => {
                const index = currentStep - 1;
                const documentoActual = requisitosDocumentos[index];
                if (!documentoActual) return null;

                const permiteComplementario = documentoActual.es_complementario_permitido;
                const limite = documentoActual.limite_documento_complementario;
                const idRequisito = documentoActual.pre; // id_requisito_documento

                return permiteComplementario && (
                  <label
                    data-tour="btn-complementaria"
                    className="mr-auto inline-flex items-center gap-2 px-5 py-2.5 rounded-2xl bg-white text-purple-700 border-2 border-purple-300 shadow-sm hover:bg-purple-600 hover:text-white hover:border-purple-600 transition-all cursor-pointer active:scale-95 group/btn"
                  >
                    <FiPlus className="h-4 w-4 group-hover/btn:rotate-90 transition-transform" />
                    <span className="font-black text-[10px] uppercase tracking-widest">Agregar Complementaria</span>
                    <input
                      type="file"
                      className="hidden"
                      onChange={(e) => handleComplementariaUpload(e, limite, idRequisito)}
                      multiple
                    />
                  </label>
                );
              })()}
            >
              {
                requisitosDocumentos.map((documento) => (
                  <Step key={documento.nombre}>
                    {(!documentosYaSubidos.includes(documento.pre) || isResubiendoDocumentos) ? (
                      <div data-tour="file-upload-section" className="max-w-xl mx-auto w-full">
                        <FileUpload
                          numero={id}
                          numeroAfiliado={numeroAfiliado}
                          etiqueta={documento.nombre}
                          requisitosDocumentoCompleto={documento}
                          onChange={(archivos) =>
                            setArchivosPorDocumento((prev) => ({
                              ...prev,
                              [documento.nombre]: archivos,
                            }))
                          }
                        />
                      </div>
                    ) : (
                      <div className="bg-white border-2 border-green-300 p-8 rounded-[2rem] flex flex-col items-center text-center gap-4">
                        <div className="size-14 bg-green-500 text-white rounded-2xl flex items-center justify-center text-2xl shadow-lg shadow-green-500/20">
                          <FiCheckCircle />
                        </div>
                        <p className="text-green-800 font-bold tracking-tight">¡Documento validado!</p>
                      </div>
                    )}
                  </Step>
                ))
              }
              <Step>
                <div className="py-10 flex flex-col items-center gap-6 max-w-2xl mx-auto">
                  <div className="size-20 bg-primary text-white rounded-[2rem] flex items-center justify-center text-4xl shadow-2xl shadow-primary/30">
                    <FiCheckCircle />
                  </div>
                  <div className="space-y-2 text-center">
                    <h2 className="text-xl font-bold text-[#1a1a1a] tracking-tight">
                      ✔ Firma Completada
                    </h2>
                    <p className="text-gray-400 font-medium text-sm">Todos los documentos están cargados. <br />Pulsa finalizar para cerrar el proceso.</p>
                  </div>
 
                  {tipoPrestamo?.toLowerCase() === "rentas" && (
                    <motion.label
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      className={`mt-4 flex items-start gap-4 p-5 rounded-2xl border-2 transition-all cursor-pointer select-none active:scale-[0.99] ${
                        declaratoriaAceptada
                          ? "bg-purple-50/50 border-primary shadow-md shadow-primary/5"
                          : "bg-white border-slate-200 hover:border-slate-300"
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={declaratoriaAceptada}
                        onChange={(e) => setDeclaratoriaAceptada(e.target.checked)}
                        className="mt-1.5 size-5 rounded border-slate-300 text-primary focus:ring-primary accent-primary cursor-pointer flex-shrink-0"
                      />
                      <span className="text-xs sm:text-sm font-semibold text-slate-700 leading-relaxed text-left">
                        Declaro bajo protesta de decir verdad que no cuento con crédito hipotecario vigente o concluido a mi nombre, por lo que puedo ser beneficiario del arrendamiento habitacional del IPEJAL.
                      </span>
                    </motion.label>
                  )}
                </div>
              </Step>
            </Stepper>)}
          </div>

          {/* Panel de Notas lateral, sale de derecha a izquierda si hay notas activas en el documento actual (Solo Escritorio) */}
          <AnimatePresence>
            {tieneNotasActivas && (
              <motion.div
                data-tour="indicaciones-panel-desktop"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ type: "spring", damping: 25, stiffness: 200 }}
                className="hidden lg:flex lg:w-[350px] shrink-0 bg-white border border-slate-200 rounded-[2.5rem] p-6 shadow-xl shadow-slate-100/50 flex-col lg:sticky lg:top-8 max-h-[calc(100vh-100px)] overflow-hidden"
              >
                {/* Header del panel */}
                <div className="flex items-center gap-3 border-b border-slate-100 pb-3 mb-3">
                  <div className="size-8 lg:size-10 bg-primary text-white border border-primary/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <FiAlertCircle className="size-4.5 lg:size-5" />
                  </div>
                  <div>
                    <h3 className="text-[11px] lg:text-xs font-black text-slate-800 uppercase tracking-wider">
                      Indicaciones del Requisito
                    </h3>
                    <p className="text-[9px] lg:text-[10px] text-slate-400 font-bold uppercase tracking-widest leading-none mt-1">
                      {documentoActual?.nombre}
                    </p>
                  </div>
                </div>

                {/* Listado de indicaciones (siempre visible en escritorio) */}
                <div className="flex-1 overflow-y-auto space-y-3 pr-1 custom-scrollbar">
                  {documentoActual?.notas_requisitos
                    ?.filter((n) => n.es_activo)
                    .map((nota, idx) => (
                      <div
                        key={nota.id_nota_requisito || idx}
                        className="bg-white border border-slate-200 rounded-2xl p-4 transition-all duration-200 shadow-xs"
                      >
                        <div className="flex flex-col gap-2">
                          <div className="flex-1 min-w-0">
                            <h4 className="text-[11px] font-black text-slate-800 uppercase tracking-wide">
                              {nota.titulo}
                            </h4>
                            {nota.vigencia && (
                              <div className="inline-block bg-white text-primary border border-primary/20 text-[7px] font-black uppercase tracking-widest px-2 py-0.5 rounded-md mt-1">
                                Vigencia: {nota.vigencia}
                              </div>
                            )}
                          </div>
                          <p className="text-slate-600 text-xs font-semibold leading-relaxed pt-2.5 border-t border-slate-100">
                            {nota.descripcion}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Panel de Notas a pantalla completa (Solo Móvil) */}
          <AnimatePresence>
            {openMobileNotas && tieneNotasActivas && (
              <motion.div
                initial={{ opacity: 0, y: "100%" }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: "100%" }}
                transition={{ type: "spring", damping: 25, stiffness: 220 }}
                className="lg:hidden fixed inset-0 bg-white z-[200] flex flex-col p-6 overflow-hidden"
              >
                {/* Header */}
                <div className="flex items-center justify-between border-b border-slate-100 pb-4 mb-6">
                  <div className="flex items-center gap-3">
                    <div className="size-10 bg-primary text-white border border-primary/20 rounded-xl flex items-center justify-center flex-shrink-0">
                      <FiAlertCircle className="size-5" />
                    </div>
                    <div>
                      <h3 className="text-xs font-black text-slate-800 uppercase tracking-wider">
                        Indicaciones
                      </h3>
                      <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-1 leading-none">
                        {documentoActual?.nombre}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => setOpenMobileNotas(false)}
                    className="size-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center text-slate-800 hover:bg-red-600 hover:text-white hover:border-red-600 active:scale-95 transition-all shadow-sm"
                  >
                    <FiX className="size-5" />
                  </button>
                </div>

                {/* Listado de indicaciones en móvil */}
                <div 
                  ref={mobileScrollRef}
                  onScroll={checkMobileScroll}
                  className="flex-1 overflow-y-auto space-y-4 pr-1 custom-scrollbar"
                >
                  {documentoActual?.notas_requisitos
                    ?.filter((n) => n.es_activo)
                    .map((nota, idx) => (
                      <div
                        key={nota.id_nota_requisito || idx}
                        className="bg-white border border-slate-200 rounded-2xl p-5 relative shadow-xs"
                      >
                        {nota.vigencia && (
                          <div className="inline-block bg-white text-primary border border-primary/20 text-[8px] font-black uppercase tracking-widest px-2.5 py-1 rounded-lg mb-3">
                            Vigencia: {nota.vigencia}
                          </div>
                        )}
                        <h4 className="text-xs font-black text-slate-800 uppercase tracking-wide mb-2">
                          {nota.titulo}
                        </h4>
                        <p className="text-slate-600 text-xs font-semibold leading-relaxed">
                          {nota.descripcion}
                        </p>
                      </div>
                    ))}
                </div>

                {/* Floating "Ver más" scroll down indicator */}
                <AnimatePresence>
                  {showScrollDownBtn && (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      className="absolute bottom-24 left-1/2 -translate-x-1/2 z-10 pointer-events-auto"
                    >
                      <button
                        type="button"
                        onClick={handleScrollDownMobile}
                        className="flex items-center gap-1.5 px-4 py-2.5 bg-[#121214] border border-zinc-800 text-white rounded-full text-[10px] font-black uppercase tracking-wider shadow-lg hover:scale-105 active:scale-95 transition-all"
                      >
                        <span>Ver más</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="size-3.5 text-emerald-400 animate-bounce" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                        </svg>
                      </button>
                    </motion.div>
                  )}
                </AnimatePresence>

                {/* Footer */}
                <div className="mt-6 border-t border-slate-100 pt-6">
                  <button
                    onClick={() => setOpenMobileNotas(false)}
                    className="w-full py-4 bg-primary text-white font-black text-[10px] uppercase rounded-xl hover:bg-primary/95 transition-all shadow-md active:scale-95 tracking-widest"
                  >
                    Entendido y volver
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      ) ) : (
        <motion.div
          key="listado-prestamos"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <div className="p-4 md:px-8 md:py-6 border-b border-slate-100 bg-slate-50/50">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="size-9 bg-primary/10 rounded-xl flex items-center justify-center text-primary shadow-sm border border-primary/5">
                  <FiLayers className="size-4.5" />
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                  <h3 data-tour="nombre-modulo" className="text-lg font-bold text-[#1a1a1a] tracking-tight">{nombreLargo || tipoPrestamo}</h3>
                  {sedeName && (
                    <div className="inline-flex items-center gap-1.5 bg-slate-50 border border-slate-200 rounded-xl px-2.5 py-1 text-slate-600 text-[10px] font-medium leading-none shadow-sm">
                      <FiMapPin className="size-3.5 text-slate-400" />
                      <span>Sede: <strong className="text-slate-800 font-bold">{sedeName}</strong></span>
                      {sedesList.length > 1 && puedeCambiarSede && (
                        <>
                          <span className="w-[1px] h-3 bg-slate-200 mx-1" />
                          <button
                            type="button"
                            onClick={() => {
                              setIdSede(null);
                              localStorage.removeItem("id_sede");
                            }}
                            className="text-[9px] font-extrabold text-primary hover:underline uppercase tracking-wider transition-colors cursor-pointer focus:outline-none"
                          >
                            Cambiar
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
                {/* Grupo de botones principales en una sola fila siempre */}
                <div className="flex items-center gap-2">
                  <button
                    onClick={handleVerRequisitos}
                    title="Ver documentos requeridos"
                    className="flex-1 sm:flex-initial flex items-center justify-center gap-1.5 px-3 h-10 bg-white border border-slate-200 rounded-xl text-primary hover:text-primary hover:border-primary/30 transition-all shadow-sm active:scale-95 text-[10px] font-extrabold uppercase tracking-wider"
                  >
                    <FiFileText className="size-4" />
                    <span>Requisitos</span>
                  </button>
                  <button
                    onClick={handleStartTour}
                    title="Ver guía de este módulo"
                    className="flex-1 sm:flex-initial flex items-center justify-center gap-1.5 px-3 h-10 bg-white border border-slate-200 rounded-xl text-primary hover:text-primary hover:border-primary/30 transition-all shadow-sm active:scale-95 text-[10px] font-extrabold uppercase tracking-wider"
                  >
                    <FiHelpCircle className="size-4" />
                    <span>Guía</span>
                  </button>
                  <button
                    onClick={() => {
                      setGlobalFilter("");
                      validar();
                      if (tipoPrestamo?.toLowerCase() === "rentas") {
                        fetchRentasTramiteInfo();
                      }
                      if (onRecargar) {
                        onRecargar();
                      }
                    }}
                    title="Recargar listado"
                    className="flex items-center justify-center size-10 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-primary hover:border-primary/30 transition-all shadow-sm active:scale-95 flex-shrink-0"
                  >
                    <FiRefreshCcw className={twMerge("size-4", cargando && "animate-spin")} />
                  </button>
                </div>

                {datos.length > 0 && (
                  <div className="relative">
                    <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 size-3.5" />
                    <input
                      type="text"
                      placeholder="Buscar..."
                      value={globalFilter}
                      onChange={(e) => setGlobalFilter(e.target.value)}
                      className="w-full sm:w-56 pl-9 pr-4 py-2 bg-white border border-slate-200 rounded-xl focus:border-primary/30 focus:ring-4 focus:ring-primary/5 outline-none font-bold text-xs transition-all placeholder:text-slate-300 shadow-sm"
                    />
                  </div>
                )}

                {mostrarBtnIniciarTramite && (
                  <button
                    onClick={handleIniciarTramite}
                    data-tour="iniciar-tramite-btn"
                    className="flex items-center justify-center gap-2 bg-primary text-white py-2.5 px-6 rounded-xl font-bold text-[10px] uppercase tracking-widest shadow-lg shadow-primary/10 hover:translate-y-[-2px] active:translate-y-0 transition-all"
                  >
                    <FiPlus className="text-sm" />
                    <span>Iniciar Trámite</span>
                  </button>
                )}


              </div>
            </div>
          </div>

          {/* Banner de aviso para trámite POR VENCER */}
          {tipoPrestamo?.toLowerCase() === "rentas" && (() => {
            const listRentas = rentasTramiteList && rentasTramiteList.length > 0
              ? rentasTramiteList
              : (rentasTramiteInfo ? [rentasTramiteInfo] : []);
            const itemPorVencer = listRentas.find(i => i?.tramite_estatus?.toUpperCase()?.trim() === "POR VENCER");
            if (!itemPorVencer) return null;

            const cleanFolio = (f) => f ? String(f).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
            const cleanPorVencerFolio = cleanFolio(itemPorVencer.folio_tramite);

            // Buscar en la lista de preregistros el registro asociado a este folio
            const preregistroAsociado = datos?.find(d => {
              const cF = cleanFolio(d.folio);
              return cF && (
                cF === cleanPorVencerFolio ||
                cF === `${cleanPorVencerFolio}R` ||
                cleanPorVencerFolio.startsWith(cF) ||
                cF.startsWith(cleanPorVencerFolio)
              );
            });

            // El botón sólo aparece si Estatus Documentos es Aprobado
            const estatusDoc = preregistroAsociado?.nombre_estado?.toUpperCase()?.trim() || "";
            if (estatusDoc !== "APROBADO") return null;

            return (
              <div className="mx-8 mt-6 p-5 bg-amber-50 border border-amber-200 rounded-[2rem] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 shadow-sm">
                <div className="flex items-start gap-3">
                  <div className="p-2.5 bg-amber-100/80 text-amber-700 rounded-2xl">
                    <FiAlertCircle className="size-6" />
                  </div>
                  <div>
                    <h4 className="text-sm font-black text-amber-800 uppercase tracking-wider">Su trámite de renta está por vencer</h4>
                    <p className="text-xs text-amber-700 font-bold mt-1">
                      Fecha de vencimiento: <span className="underline">{(() => {
                        const dateVal = itemPorVencer.fecha_vencido || itemPorVencer.fecha_vencimiento || itemPorVencer.fecha_por_vencer;
                        if (!dateVal) return "-";
                        try {
                          return new Date(dateVal).toLocaleDateString('es-MX', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                          });
                        } catch (e) {
                          return dateVal;
                        }
                      })()}</span>. Por favor, resuba sus documentos para renovar su solicitud.
                    </p>
                  </div>
                </div>
                <button
                  onClick={handleResubirDocumentosPorVencer}
                  data-target-folio={itemPorVencer.folio_tramite}
                  data-tour="resubir-documentos-btn"
                  className="flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white py-2.5 px-5 rounded-xl font-bold text-[10px] uppercase tracking-widest shadow-md transition-all active:scale-95 whitespace-nowrap self-start sm:self-auto"
                >
                  <FiRefreshCcw className="size-3.5" />
                  <span>Resubir Documentos</span>
                </button>
              </div>
            );
          })()}

          <button
            onClick={handleResubirDocumentosPorVencer}
            data-tour="resubir-documentos-btn-hidden"
            className="hidden"
          />

          {/* Banner de aviso para trámite OFERTA DISPONIBLE */}
          {tipoPrestamo?.toLowerCase() === "rentas" && 
           (rentasTramiteInfo?.tramite_estatus?.toUpperCase()?.trim() === "OFERTA DISPONIBLE" ||
            rentasTramiteInfo?.tramite_estatus?.toUpperCase()?.trim() === "OFERTA_DISPONIBLE") && (
            <div className="mx-8 mt-6 p-5 bg-emerald-50 border border-emerald-200 rounded-[2rem] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 shadow-sm">
              <div className="flex items-start gap-3">
                <div className="p-2.5 bg-emerald-100/80 text-emerald-700 rounded-2xl">
                  <FiHome className="size-6" />
                </div>
                <div>
                  <h4 className="text-sm font-black text-emerald-800 uppercase tracking-wider">Tiene una oferta de inmueble disponible</h4>
                  <p className="text-xs text-emerald-700 font-bold mt-1">
                    Revise las opciones disponibles y seleccione la que más le convenga para aceptar su oferta.
                  </p>
                </div>
              </div>
              <button
                onClick={() => setOfertaModalAbierto(true)}
                className="flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white py-2.5 px-5 rounded-xl font-bold text-[10px] uppercase tracking-widest shadow-md transition-all active:scale-95 whitespace-nowrap self-start sm:self-auto"
              >
                <FiCheck className="size-3.5" />
                <span>Seleccionar Oferta</span>
              </button>
            </div>
          )}

          {/* Banner de Cita de Continuidad Vigente (para volver a pantalla completa) */}
          {citaContinuidadData && !mostrarVistaContinuidad && (
            <div className="mx-4 md:mx-8 mt-5 p-4 md:p-5 bg-white border border-slate-200 rounded-2xl flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 shadow-2xs">
              <div className="flex items-start gap-3.5">
                <div className="size-10 rounded-xl bg-slate-50 border border-slate-200 text-slate-600 flex items-center justify-center shrink-0">
                  <FiCalendar className="size-5" />
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <div className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-slate-50 border border-slate-200 text-xs font-medium text-slate-700">
                      <span className="size-1.5 rounded-full bg-emerald-500 shrink-0" />
                      <span>Cita de Continuidad Vigente</span>
                    </div>
                    <span className="text-xs font-mono text-slate-500">
                      Folio #{citaContinuidadData.folio}
                    </span>
                  </div>
                  <h4 className="text-base font-bold text-slate-900 tracking-tight">
                    {citaContinuidadData.tramite}
                  </h4>
                  <p className="text-xs font-normal text-slate-500 mt-0.5">
                    Programada para el <span className="font-semibold text-slate-700">{citaContinuidadData.fecha_cita}</span> a las <span className="font-semibold text-slate-700">{citaContinuidadData.hora_cita} hrs</span> en {citaContinuidadData.sede}.
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setMostrarVistaContinuidad(true)}
                className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-white hover:bg-slate-50 text-slate-700 hover:text-slate-900 border border-slate-300 rounded-xl font-medium text-xs transition-all shadow-2xs active:scale-95 whitespace-nowrap self-start sm:self-auto cursor-pointer"
              >
                <FiPrinter className="size-3.5 text-slate-500" />
                <span>Ver Cita / Imprimir</span>
              </button>
            </div>
          )}

          <div className="p-4 md:p-10">
            {/* Desktop View Table */}
            <div className="hidden md:block overflow-x-auto rounded-[1.5rem] border border-slate-100 bg-white shadow-sm mx-4 mb-4">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-slate-50/80">
                    {tipoPrestamo?.toLowerCase() !== "rentas" && (
                      <th className="px-6 py-4 text-left text-[12px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap border-b border-slate-100">ID</th>
                    )}
                    <th className="px-6 py-4 text-left text-[12px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap border-b border-slate-100">Folio</th>
                    <th className="px-6 py-4 text-center text-[12px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap border-b border-slate-100">{tipoPrestamo?.toLowerCase() === "rentas" ? "Estatus Documentos" : "Estatus"}</th>
                    {tipoPrestamo?.toLowerCase() === "rentas" && (
                      <th className="px-6 py-4 text-center text-[12px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap border-b border-slate-100">Estatus Rentas</th>
                    )}
                    <th className="px-6 py-4 text-center text-[12px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap border-b border-slate-100">
                      {tipoPrestamo?.toLowerCase() === "rentas" ? "Folio fila virtual" : "Folio Cita"}
                    </th>
                    <th className="px-6 py-4 text-center text-[12px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap border-b border-slate-100">
                      {tipoPrestamo?.toLowerCase() === "rentas" ? "Fecha" : "Fecha Cita"}
                    </th>
                    <th className="px-6 py-4 text-right text-[12px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap border-b border-slate-100">Acciones</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-50 text-[12px]">
                  {table.getRowModel().rows.length > 0 ? (
                    table.getRowModel().rows.map((row) => (
                      <tr key={row.id} className="group/row hover:bg-slate-50/50 transition-colors">
                        {tipoPrestamo?.toLowerCase() !== "rentas" && (
                          <td className="px-6 py-4 font-bold text-gray-400 italic">#{row.original.id_preregistro}</td>
                        )}
                        <td className="px-6 py-4 font-bold text-[#1a1a1a] tracking-tight">{row.original.folio}</td>
                        <td className="px-6 py-4 text-center">
                          {tipoPrestamo?.toLowerCase() === "rentas" && row.original.nombre_estado === 'Aprobado' ? (
                            <div className="flex justify-center">
                              <div className="size-6 rounded-full bg-emerald-500 text-white flex items-center justify-center shadow-xs" title="Aprobado">
                                <FiCheck className="size-3.5 stroke-[3]" />
                              </div>
                            </div>
                          ) : tipoPrestamo?.toLowerCase() === "rentas" && row.original.nombre_estado?.toLowerCase() === 'cancelado' ? (
                            <div className="flex justify-center">
                              <div className="size-6 rounded-full bg-slate-400 text-white flex items-center justify-center shadow-xs" title="Cancelado">
                                <svg className="size-3 stroke-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round">
                                  <line x1="18" y1="6" x2="6" y2="18" />
                                </svg>
                              </div>
                            </div>
                          ) : (
                            <span
                              data-tour={row.index === 0 ? "estatus-folio-badge" : undefined}
                              className={twMerge(
                                "inline-flex items-center px-3 py-1 rounded-lg text-[12px] font-bold uppercase tracking-widest border",
                                row.original.nombre_estado === 'Aprobado' ? "bg-white text-green-700 border-green-300" :
                                  (row.original.nombre_estado === 'Rechazado' || row.original.nombre_estado === 'Observado' || row.original.nombre_estado === 'Preregistro Rechazado') ? "bg-white text-red-600 border-red-300" :
                                    row.original.nombre_estado === 'Pendiente' ? "bg-white text-amber-700 border-amber-300" :
                                      "bg-white text-slate-600 border-slate-300"
                              )}
                            >
                              {row.original.nombre_estado}
                            </span>
                          )}
                        </td>
                        {tipoPrestamo?.toLowerCase() === "rentas" && (
                          <td className="px-6 py-4 text-center">
                            {(() => {
                              const est = obtenerEstatusRentasPorFolio(row.original.folio);
                              if (!est) return <span className="text-[10px] text-slate-400 italic font-bold">SIN INICIAR</span>;
                              
                              return (
                                <span className={twMerge(
                                  "inline-flex items-center px-3 py-1 rounded-xl text-[10px] font-black uppercase tracking-widest border shadow-sm",
                                  est === "EN ESPERA" ? "bg-blue-50 text-blue-700 border-blue-200" :
                                  est === "POR VENCER" ? "bg-amber-50 text-amber-700 border-amber-200" :
                                  (est === "EN RENOVACIÓN" || est === "EN RENOVACION") ? "bg-purple-50 text-purple-700 border-purple-200" :
                                  (est === "OFERTA DISPONIBLE" || est === "OFERTA_DISPONIBLE") ? "bg-emerald-50 text-emerald-700 border-emerald-200" :
                                  est === "ACEPTADO" ? "bg-indigo-50 text-indigo-700 border-indigo-200" :
                                  "bg-slate-50 text-slate-600 border-slate-200"
                                )}>
                                  {est}
                                </span>
                              );
                            })()}
                          </td>
                        )}
                        <td className="px-6 py-4 text-center font-bold text-blue-600">
                          {(() => {
                            const val = tipoPrestamo?.toLowerCase() === "rentas"
                              ? (hideFolioAndFecha ? "-" : obtenerFolioFilaVirtual(row.original.folio))
                              : (row.original.folio_cita || "-");
                            
                            if (val === "SIN INICIAR") {
                              return <span className="text-[10px] text-slate-400 italic font-bold">SIN INICIAR</span>;
                            }
                            return val;
                          })()}
                        </td>
                        <td className="px-6 py-4 text-center whitespace-nowrap">
                          {(() => {
                            const isRentas = tipoPrestamo?.toLowerCase() === "rentas";
                            const fechaVal = isRentas 
                              ? (hideFolioAndFecha ? null : row.original.fecha_preregistro) 
                              : row.original.fecha_cita;
                            if (!fechaVal) return "-";
                            try {
                              return new Date(fechaVal).toLocaleDateString('es-MX', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                              });
                            } catch (e) {
                              return fechaVal;
                            }
                          })()}
                        </td>
                        <td className="px-6 py-4 text-right">
                          <div className="flex items-center justify-end gap-2">
                            {(() => {
                              const estatus = row.original.nombre_estado || "";
                              const estatusRentas = (tipoPrestamo?.toLowerCase() === "rentas" ? obtenerEstatusRentasPorFolio(row.original.folio) : "")?.toUpperCase()?.trim() || "";
                              const isVencidoOConcluido = estatusRentas === "VENCIDO" || estatusRentas === "CONCLUIDO" || estatusRentas === "CONCLUIDA";
                              const esObservado = !isVencidoOConcluido && (["Observado", "Con Observaciones", "Rechazado"].includes(estatus) || estatus.toUpperCase() === "OBSERVADO");
                              return (
                                <button
                                  onClick={() => handleVerDetalle(row.original)}
                                  data-tour={row.index === 0 ? "abrir-detalle-btn" : undefined}
                                  className={twMerge(
                                    "inline-flex items-center justify-center gap-2 px-4 h-10 rounded-xl text-xs sm:text-[13px] font-bold tracking-normal transition-all duration-200 active:scale-95 shadow-sm whitespace-nowrap",
                                    esObservado
                                      ? "bg-primary hover:bg-primary/90 text-white shadow-primary/20"
                                      : "bg-white hover:bg-slate-50 text-slate-700 hover:text-primary border border-slate-300 hover:border-primary/40 shadow-xs"
                                  )}
                                >
                                  {esObservado ? <FiUploadCloud className="size-4 text-white" /> : <FiFileText className="size-4 text-slate-400" />}
                                  <span>{esObservado ? "Corregir Documento" : "Ver Detalle"}</span>
                                </button>
                              );
                            })()}
                            {row.original.nombre_estado === "Aprobado" && (
                              <CitaActionButton
                                row={row}
                                email={userEmail}
                                setOpenCalendarState={setOpenCalendar}
                                GetCitasDisponibles={GetCitasDisponibles}
                                apiUrl={apiUrl}
                                apiUrlAgendador={apiUrl_agendador}
                                Calendar={Calendar}
                                openCalendar={openCalendar}
                              />
                            )}

                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="px-8 py-20 text-center">
                        <div className="flex flex-col items-center gap-3">
                          <FiFileText className="size-12 text-gray-100" />
                          <p className="text-gray-300 font-bold uppercase tracking-widest text-[12px]">No hay preregistros disponibles</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Mobile View Cards */}
            <div className="md:hidden space-y-4">
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row) => (
                  <div key={row.id} className="bg-white border-2 border-gray-100 rounded-[2rem] p-6 shadow-sm transition-all">
                    <div className="flex justify-between items-start mb-6">
                      <div className="space-y-0.5">
                        {tipoPrestamo?.toLowerCase() !== "rentas" && (
                          <p className="text-[9px] font-bold text-gray-300 uppercase tracking-widest italic">#{row.original.id_preregistro}</p>
                        )}
                        <h4 className="text-xl font-bold text-[#1a1a1a] tracking-tight">{row.original.folio}</h4>
                      </div>
                      <div className="flex flex-col items-end gap-1">
                        <span className="text-[8px] text-slate-400 font-extrabold uppercase tracking-wider">
                          {tipoPrestamo?.toLowerCase() === "rentas" ? "Docs" : "Estatus"}
                        </span>
                        {tipoPrestamo?.toLowerCase() === "rentas" && row.original.nombre_estado === 'Aprobado' ? (
                          <div className="size-6 rounded-full bg-emerald-500 text-white flex items-center justify-center shadow-xs" title="Aprobado">
                            <FiCheck className="size-3.5 stroke-[3]" />
                          </div>
                        ) : tipoPrestamo?.toLowerCase() === "rentas" && row.original.nombre_estado?.toLowerCase() === 'cancelado' ? (
                          <div className="size-6 rounded-full bg-slate-400 text-white flex items-center justify-center shadow-xs" title="Cancelado">
                            <svg className="size-3 stroke-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round">
                              <line x1="18" y1="6" x2="6" y2="18" />
                            </svg>
                          </div>
                        ) : (
                          <span
                            data-tour={row.index === 0 ? "estatus-folio-badge-movil" : undefined}
                            className={twMerge(
                              "px-3 py-1.5 rounded-lg text-[8px] font-bold uppercase tracking-widest border",
                              row.original.nombre_estado === 'Aprobado' ? "bg-white text-green-700 border-green-300" :
                                (row.original.nombre_estado === 'Rechazado' || row.original.nombre_estado === 'Observado' || row.original.nombre_estado === 'Preregistro Rechazado') ? "bg-white text-red-600 border-red-300" :
                                  row.original.nombre_estado === 'Pendiente' ? "bg-white text-amber-700 border-amber-300" :
                                    "bg-white text-slate-600 border-slate-300"
                            )}
                          >
                            {row.original.nombre_estado}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="mb-4 p-3 bg-white rounded-xl border border-blue-300 flex items-center justify-between">
                        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest">
                          {tipoPrestamo?.toLowerCase() === "rentas" ? "Folio fila virtual:" : "Folio Cita:"}
                        </span>
                        {(() => {
                          const val = tipoPrestamo?.toLowerCase() === "rentas"
                            ? obtenerFolioFilaVirtual(row.original.folio)
                            : row.original.folio_cita;
                          
                          if (val === "SIN INICIAR") {
                            return <span className="text-xs text-slate-400 italic font-bold">SIN INICIAR</span>;
                          }
                          return (
                            <span className="text-sm font-bold text-blue-600">
                              {val || "-"}
                            </span>
                          );
                        })()}
                      </div>

                    {tipoPrestamo?.toLowerCase() === "rentas" && (
                      <div className="mb-4 p-3 bg-slate-50 rounded-xl border border-slate-200 flex items-center justify-between">
                        <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                          Estatus Rentas:
                        </span>
                        {(() => {
                          const est = obtenerEstatusRentasPorFolio(row.original.folio);
                          if (!est) return <span className="text-xs text-slate-400 italic font-bold">SIN INICIAR</span>;
                          return (
                            <span className={twMerge(
                              "inline-flex items-center px-2.5 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider border shadow-xs",
                              est === "EN ESPERA" ? "bg-white text-blue-700 border-blue-200" :
                              est === "POR VENCER" ? "bg-white text-amber-700 border-amber-200" :
                              (est === "EN RENOVACIÓN" || est === "EN RENOVACION") ? "bg-white text-purple-700 border-purple-200" :
                              (est === "OFERTA DISPONIBLE" || est === "OFERTA_DISPONIBLE") ? "bg-white text-emerald-700 border-emerald-200" :
                              est === "ACEPTADO" ? "bg-white text-indigo-700 border-indigo-200" :
                              "bg-white text-slate-600 border-slate-200"
                            )}>
                              {est}
                            </span>
                          );
                        })()}
                      </div>
                    )}

                    <div className="flex flex-col gap-2">
                      {(() => {
                        const estatus = row.original.nombre_estado || "";
                        const estatusRentas = (tipoPrestamo?.toLowerCase() === "rentas" ? obtenerEstatusRentasPorFolio(row.original.folio) : "")?.toUpperCase()?.trim() || "";
                        const isVencidoOConcluido = estatusRentas === "VENCIDO" || estatusRentas === "CONCLUIDO" || estatusRentas === "CONCLUIDA";
                        const esObservado = !isVencidoOConcluido && (["Observado", "Con Observaciones", "Rechazado"].includes(estatus) || estatus.toUpperCase() === "OBSERVADO");
                        return (
                          <button
                            onClick={() => handleVerDetalle(row.original)}
                            data-tour={row.index === 0 ? "abrir-detalle-btn-movil" : undefined}
                            className={twMerge(
                              "w-full flex items-center justify-center gap-2.5 px-5 h-12 rounded-2xl text-sm font-bold tracking-normal transition-all duration-200 active:scale-95 shadow-sm",
                              esObservado
                                ? "bg-primary hover:bg-primary/90 text-white shadow-primary/20"
                                : "bg-white hover:bg-slate-50 text-slate-700 hover:text-primary border border-slate-300 hover:border-primary/40 shadow-xs"
                            )}
                          >
                            {esObservado ? <FiUploadCloud className="size-5 shrink-0 text-white" /> : <FiFileText className="size-5 shrink-0 text-slate-400" />}
                            <span>{esObservado ? "Corregir Documento" : "Ver Detalle"}</span>
                            <FiChevronRight className="size-4.5 shrink-0 ml-1 opacity-70" />
                          </button>
                        );
                      })()}
                      {row.original.nombre_estado === "Aprobado" && (
                        <CitaActionButton
                          row={row}
                          email={userEmail}
                          setOpenCalendarState={setOpenCalendar}
                          GetCitasDisponibles={GetCitasDisponibles}
                          apiUrl={apiUrl}
                          apiUrlAgendador={apiUrl_agendador}
                          Calendar={Calendar}
                          openCalendar={openCalendar}
                          isMobile={true}
                        />
                      )}

                    </div>
                  </div>
                ))
              ) : (
                <div className="py-20 text-center flex flex-col items-center gap-4 text-gray-200">
                  <FiFileText className="size-16" />
                  <p className="text-xs font-black uppercase tracking-widest">Sin registros</p>
                </div>
              )}
            </div>
          </div>

          <AnimatePresence>
            {registroSeleccionado && (
              <>
                {/* Fondo oscuro traslúcido para cerrar al hacer clic fuera */}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => {
                    stopTour();
                    setRegistroSeleccionado(null);
                  }}
                  className="fixed inset-0 bg-black/35 backdrop-blur-xs z-[140]"
                />

                {/* Panel lateral deslizable de derecha a izquierda */}
                <motion.div
                  ref={detalleRef}
                  initial={{ x: "100%" }}
                  animate={{ x: 0 }}
                  exit={{ x: "100%" }}
                  transition={{ type: "spring", damping: 30, stiffness: 300 }}
                  className="fixed right-0 top-0 bottom-0 h-screen w-full md:w-1/2 lg:w-1/2 bg-slate-50 border-l border-slate-200/80 shadow-2xl z-[150] overflow-hidden flex flex-col rounded-l-[2rem] sm:rounded-l-[2.5rem]"
                >
                  <div className="absolute top-0 right-0 p-10 opacity-5 pointer-events-none">
                    <FiFileText className="size-40 text-primary" />
                  </div>

                  <header className="flex justify-between items-center p-6 sm:p-8 border-b border-slate-200/60 relative z-10 bg-white">
                    <div data-tour="detalle-panel-header" className="space-y-1">
                      <h2 className="text-lg sm:text-xl font-black text-slate-800 tracking-tight uppercase">ABRIR DETALLE DE REGISTRO</h2>
                      <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Información detallada y bitácora</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={handleStartTour}
                        className="flex items-center justify-center gap-1.5 px-3.5 py-2 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl text-primary hover:border-primary/30 transition-all shadow-sm active:scale-95 text-[10px] font-extrabold uppercase tracking-wider"
                      >
                        <FiHelpCircle className="size-3.5" />
                        <span>Guía Detalle</span>
                      </button>
                      <button
                        className="size-10 flex items-center justify-center bg-slate-50 hover:bg-red-50 text-slate-500 hover:text-red-600 rounded-xl border border-slate-200 hover:border-red-200 transition-all active:scale-95 shadow-sm"
                        onClick={() => {
                          stopTour();
                          setRegistroSeleccionado(null);
                        }}
                      >
                        <FiX className="text-xl" />
                      </button>
                    </div>
                  </header>

                  <div className="relative z-10 flex-1 overflow-y-auto p-6 sm:p-8 custom-scrollbar">
                    <DetallePreregistro
                      data={registroSeleccionado}
                      bitacora={detalleDocumento}
                      bitacora_doc={detalleDocumento_sub}
                      reloadDetail={() => {
                        validar(true);
                        handleVerDetalle(registroSeleccionado);
                      }}
                    />
                  </div>
                </motion.div>
              </>
            )}
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  )}
      <AnimatePresence>
        {alerta && (
          <Alerta
            tipo={alerta.tipo}
            titulo={alerta.titulo}
            mensaje={alerta.mensaje}
            onClose={() => setAlerta(null)}
            onClick={alerta.onClick}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showRequisitosModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/45 backdrop-blur-sm z-[250] flex items-center justify-center p-4 md:p-6"
            onClick={() => setShowRequisitosModal(false)}
          >
            <motion.div
              initial={{ scale: 0.95, y: 15 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.95, y: 15 }}
              transition={{ type: "spring", damping: 25, stiffness: 220 }}
              className="bg-white border border-slate-200 rounded-[2.5rem] p-6 md:p-10 w-full max-w-2xl md:max-w-3xl shadow-2xl flex flex-col max-h-[85vh] overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex items-center justify-between border-b border-slate-100 pb-5 mb-5">
                <div className="flex items-center gap-4">
                  <div className="size-12 bg-primary/10 text-primary rounded-2xl flex items-center justify-center">
                    <FiFileText className="size-6" />
                  </div>
                  <div>
                    <h3 className="text-base sm:text-lg font-black text-slate-800 uppercase tracking-wider">
                      Documentos Requeridos
                    </h3>
                    <p className="text-xs text-slate-400 font-bold uppercase tracking-wider mt-1">
                      {nombreLargo || tipoPrestamo}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setShowRequisitosModal(false)}
                  className="size-10 rounded-2xl bg-white border border-slate-200 flex items-center justify-center text-slate-800 hover:bg-red-50 hover:text-red-600 hover:border-red-200 active:scale-95 transition-all shadow-sm"
                >
                  <FiX className="size-5" />
                </button>
              </div>

              {/* Body */}
              <div className="flex-1 overflow-y-auto pr-2 py-2 custom-scrollbar">
                {loadingModalRequisitos ? (
                  <div className="py-16 flex flex-col items-center gap-4 text-center">
                    <FiClock className="size-10 text-primary animate-spin" />
                    <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Consultando requisitos...</p>
                  </div>
                ) : requisitosModalData.length === 0 ? (
                  <div className="py-16 flex flex-col items-center gap-3 text-center text-slate-400">
                    <FiFileText className="size-12 text-slate-200" />
                    <p className="text-sm font-black uppercase tracking-wider">No se encontraron requisitos configurados</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {requisitosModalData.map((doc, idx) => (
                      <div
                        key={idx}
                        className="bg-white border border-slate-200 rounded-2xl p-5 flex flex-col gap-3 transition-all hover:border-slate-300"
                      >
                        <div className="flex items-start justify-between gap-4">
                          <h4 className="text-sm sm:text-base font-bold text-slate-800 tracking-tight leading-snug">
                            {doc.nombre}
                          </h4>
                          <span
                            className={twMerge(
                              "px-3 py-1 rounded-xl text-[10px] font-black uppercase tracking-wider border flex-shrink-0",
                              doc.es_obligatorio
                                ? "bg-white text-red-600 border-red-200"
                                : "bg-white text-slate-500 border-slate-200"
                            )}
                          >
                            {doc.es_obligatorio ? "Obligatorio" : "Opcional"}
                          </span>
                        </div>

                        {doc.notas_requisitos && doc.notas_requisitos.filter(n => n.es_activo).length > 0 && (
                          <div className="mt-1.5 pt-3 border-t border-slate-100 space-y-2">
                            {doc.notas_requisitos
                              .filter((n) => n.es_activo)
                              .map((nota, nIdx) => (
                                <div key={nIdx} className="text-xs leading-relaxed font-medium text-slate-500">
                                  • <strong className="text-slate-700">{nota.titulo}:</strong> {nota.descripcion}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="mt-5 border-t border-slate-100 pt-5 flex justify-end">
                <button
                  onClick={() => setShowRequisitosModal(false)}
                  className="px-8 py-3 bg-primary text-white font-black text-xs sm:text-sm uppercase rounded-xl hover:bg-primary/95 transition-all shadow-md active:scale-95 tracking-widest"
                >
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal Aceptar Oferta de Inmuebles */}
      <AnimatePresence>
        {ofertaModalAbierto && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setOfertaModalAbierto(false)}
              className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
            />

            {/* Modal Content */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              className="relative bg-white w-full max-w-lg rounded-[2.5rem] shadow-2xl border border-slate-100 overflow-hidden flex flex-col z-10 p-6 md:p-8"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="p-3 bg-emerald-100/80 text-emerald-700 rounded-2xl">
                    <FiHome className="size-6 animate-bounce" />
                  </div>
                  <div>
                    <h3 className="text-lg font-black text-slate-800 uppercase tracking-wider">Aceptar Oferta</h3>
                    <p className="text-xs text-slate-400 font-bold">Seleccione la opción de inmueble que desea aceptar</p>
                  </div>
                </div>
                <button
                  onClick={() => setOfertaModalAbierto(false)}
                  className="size-10 flex items-center justify-center text-slate-400 hover:bg-slate-50 hover:text-slate-600 rounded-xl transition-colors active:scale-95"
                >
                  <FiX className="size-5" />
                </button>
              </div>

              {/* Ofertas List */}
              <div className="flex flex-col gap-4 mb-8 max-h-[300px] overflow-y-auto pr-1">
                {cargandoOfertaDetalle ? (
                  <div className="py-16 flex flex-col items-center gap-4 text-center">
                    <div className="size-8 border-4 border-emerald-200 border-t-emerald-600 rounded-full animate-spin" />
                    <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Cargando ofertas disponibles...</p>
                  </div>
                ) : (
                  <>
                    {obtenerOfertasDisponibles().map((opt) => {
                      const seleccionado = seleccionOferta === opt.numero;
                      return (
                        <div
                          key={opt.numero}
                          onClick={() => setSeleccionOferta(opt.numero)}
                          className={`p-5 rounded-3xl border-2 cursor-pointer transition-all active:scale-[0.98] ${
                            seleccionado
                              ? "bg-emerald-50/50 border-emerald-500 shadow-md shadow-emerald-500/5"
                              : "bg-white border-slate-100 hover:border-slate-200 hover:bg-slate-50/30"
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex flex-col gap-1">
                              <span className="text-[10px] text-slate-400 font-black uppercase tracking-wider">Opción {opt.numero}</span>
                              <span className="text-sm font-black text-slate-800">{opt.opcion}</span>
                              <div className="flex items-center gap-4 mt-2">
                                <div className="flex flex-col">
                                  <span className="text-[8px] text-slate-400 font-bold uppercase">Clave Opción</span>
                                  <span className="text-[11px] text-slate-700 font-extrabold">{opt.clave}</span>
                                </div>
                                <div className="flex flex-col">
                                  <span className="text-[8px] text-slate-400 font-bold uppercase">Código Oferta</span>
                                  <span className="text-[11px] text-slate-700 font-extrabold">{opt.oferta}</span>
                                </div>
                              </div>
                            </div>

                            {/* Radio indicator */}
                            <div
                              className={`size-6 rounded-full border-2 flex items-center justify-center transition-all ${
                                seleccionado
                                  ? "border-emerald-500 bg-emerald-500 text-white"
                                  : "border-slate-200 bg-white"
                              }`}
                            >
                              {seleccionado && <FiCheck className="size-4 stroke-[3px]" />}
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    {obtenerOfertasDisponibles().length === 0 && (
                      <div className="py-12 text-center text-slate-400 text-xs font-bold bg-slate-50 rounded-3xl border-2 border-dashed border-slate-100 flex flex-col items-center gap-2">
                        <FiXCircle className="size-8 text-slate-300" />
                        <span>No hay ofertas de inmuebles disponibles en este momento.</span>
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end gap-3 border-t border-slate-100 pt-5">
                <button
                  onClick={handleRechazarOferta}
                  disabled={rechazandoOferta || aceptandoOferta}
                  className="px-5 py-3 text-red-600 hover:bg-red-50 disabled:bg-slate-100 disabled:text-slate-400 rounded-2xl font-bold text-[10px] uppercase tracking-widest transition-colors flex items-center justify-center gap-2"
                >
                  {rechazandoOferta ? (
                    <>
                      <div className="size-3.5 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
                      <span>Rechazando...</span>
                    </>
                  ) : (
                    <span>Rechazar Oferta</span>
                  )}
                </button>
                <button
                  onClick={handleAceptarOferta}
                  disabled={!seleccionOferta || aceptandoOferta || rechazandoOferta}
                  className="px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white disabled:bg-slate-100 disabled:text-slate-400 rounded-2xl font-bold text-[10px] uppercase tracking-widest shadow-md hover:shadow-lg disabled:shadow-none transition-all active:scale-95 flex items-center justify-center gap-2"
                >
                  {aceptandoOferta ? (
                    <>
                      <div className="size-3.5 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
                      <span>Aceptando...</span>
                    </>
                  ) : (
                    <span>Aceptar Oferta</span>
                  )}
                </button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      <FullLoaderTramite visible={mostrarFullLoader4s} nombreTramite={nombreLargo} />

    </div>
  );
};

const SkeletonRequisitos = () => {
  return (
    <div className="w-full flex flex-col gap-6">
      {/* Top Header */}
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div className="flex items-center gap-2">
          <div className="w-32 h-7 bg-neutral-100 rounded-xl animate-pulse" />
          <div className="w-20 h-7 bg-neutral-100 rounded-xl animate-pulse" />
        </div>
        <div className="w-24 h-8 bg-neutral-100 rounded-xl animate-pulse" />
      </div>

      <div className="flex flex-col lg:flex-row gap-6 items-start">
        {/* Main Upload Box Skeleton */}
        <div className="flex-1 w-full bg-white border border-neutral-200 rounded-[2.5rem] p-6 md:p-10 flex flex-col gap-8">
          {/* Stepper circles */}
          <div className="flex items-center justify-between px-4 py-3 bg-white border border-neutral-100 rounded-2xl">
            {[1, 2, 3, 4].map((i) => (
              <React.Fragment key={i}>
                <div className="size-8 rounded-full bg-neutral-100 animate-pulse" />
                {i < 4 && <div className="flex-1 h-0.5 mx-2 bg-neutral-100 animate-pulse" />}
              </React.Fragment>
            ))}
          </div>

          {/* Upload card */}
          <div className="w-full h-72 md:h-80 border-2 border-dashed border-neutral-200 rounded-[2rem] bg-white flex flex-col items-center justify-center gap-4 p-8">
            <div className="size-16 rounded-2xl bg-neutral-100 animate-pulse" />
            <div className="w-48 h-5 bg-neutral-100 rounded-lg animate-pulse" />
            <div className="w-64 h-3 bg-neutral-100 rounded-lg animate-pulse" />
          </div>

          {/* Action buttons */}
          <div className="flex items-center justify-between border-t border-slate-100 pt-6">
            <div className="w-24 h-10 bg-neutral-100 rounded-xl animate-pulse" />
            <div className="w-24 h-10 bg-neutral-100 rounded-xl animate-pulse" />
          </div>
        </div>

        {/* Sidebar Notes Skeleton (Desktop only) */}
        <div className="hidden lg:flex lg:w-[350px] shrink-0 bg-white border border-neutral-200 rounded-[2.5rem] p-6 flex-col gap-6 h-[500px]">
          {/* Notes Header */}
          <div className="flex items-center gap-3 border-b border-slate-100 pb-3">
            <div className="size-10 bg-neutral-100 rounded-xl animate-pulse" />
            <div className="flex-1 flex flex-col gap-2">
              <div className="w-32 h-4 bg-neutral-100 rounded-lg animate-pulse" />
              <div className="w-20 h-3 bg-neutral-100 rounded-lg animate-pulse" />
            </div>
          </div>

          {/* Notes Items */}
          <div className="flex-1 flex flex-col gap-4">
            {[1, 2].map((i) => (
              <div key={i} className="border border-neutral-100 rounded-2xl p-4 flex flex-col gap-3">
                <div className="flex flex-col gap-1.5">
                  <div className="w-24 h-3.5 bg-neutral-100 rounded-md animate-pulse" />
                  <div className="w-16 h-3.5 bg-neutral-100 rounded-md animate-pulse" />
                </div>
                <div className="flex flex-col gap-2 border-t border-slate-100 pt-2.5">
                  <div className="w-full h-3 bg-neutral-100 rounded-md animate-pulse" />
                  <div className="w-5/6 h-3 bg-neutral-100 rounded-md animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Validador;
